// Generated from ./util_cohort_builder_grammar/stable/SimpleEvents.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { SimpleEventsListener } from "./SimpleEventsListener.js";
import { SimpleEventsVisitor } from "./SimpleEventsVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class SimpleEvents extends antlr.Parser {
    public static readonly CF = 1;
    public static readonly CONCEPT_FILTER = 2;
    public static readonly CONCEPT_FILTER_ABBR = 3;
    public static readonly NF = 4;
    public static readonly NUMERIC_FILTER = 5;
    public static readonly NUMERIC_FILTER_ABBR = 6;
    public static readonly SF = 7;
    public static readonly STRING_FILTER = 8;
    public static readonly STRING_FILTER_ABBR = 9;
    public static readonly UF = 10;
    public static readonly UNIQUENESS_FILTER = 11;
    public static readonly UNIQUENESS_FILTER_ABBR = 12;
    public static readonly RF = 13;
    public static readonly RELATED_ENTITY_FILTER = 14;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 15;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 16;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 17;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 18;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 19;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 20;
    public static readonly QUALIFIED_PERSON_ALIAS = 21;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 22;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 23;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 24;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 25;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 26;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 27;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 28;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 29;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 30;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 31;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 32;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 33;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 34;
    public static readonly CONCEPT_GROUP = 35;
    public static readonly CARE_SITE_ALIAS = 36;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 37;
    public static readonly DRUG_EXPOSURE_ALIAS = 38;
    public static readonly MEASUREMENT_ALIAS = 39;
    public static readonly OBSERVATION_ALIAS = 40;
    public static readonly PERSON_ALIAS = 41;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 42;
    public static readonly PROVIDER_ALIAS = 43;
    public static readonly VISIT_OCCURRENCE_ALIAS = 44;
    public static readonly MERGED_EVENT_NAME = 45;
    public static readonly SEQUENCE_EVENT_NAME = 46;
    public static readonly INSTANCE_EVENT_NAME = 47;
    public static readonly SUBJECTS_VARIABLE_NAME = 48;
    public static readonly NAMESPACE_QUALIFIER = 49;
    public static readonly SUBJECTS_VARIABLE = 50;
    public static readonly CONCEPT = 51;
    public static readonly QUALIFIED_MERGED_EVENT = 52;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 53;
    public static readonly QUALIFIED_INSTANCE_EVENT = 54;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 55;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 56;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 57;
    public static readonly MERGED_EVENT = 58;
    public static readonly SEQUENCE_EVENT = 59;
    public static readonly INSTANCE_EVENT = 60;
    public static readonly DERIVED_EVENT = 61;
    public static readonly LINE_COMMENT = 62;
    public static readonly INT = 63;
    public static readonly M = 64;
    public static readonly D = 65;
    public static readonly Y = 66;
    public static readonly DATE = 67;
    public static readonly OPEN_PAREN = 68;
    public static readonly CLOSE_PAREN = 69;
    public static readonly SEMICOLON = 70;
    public static readonly COMMA = 71;
    public static readonly EQ = 72;
    public static readonly MULTIPLY = 73;
    public static readonly DIVIDE = 74;
    public static readonly ADD = 75;
    public static readonly SUBTRACT = 76;
    public static readonly CONTAINS = 77;
    public static readonly NEQ = 78;
    public static readonly LTE = 79;
    public static readonly GTE = 80;
    public static readonly LT = 81;
    public static readonly GT = 82;
    public static readonly MAX = 83;
    public static readonly MIN = 84;
    public static readonly AVG = 85;
    public static readonly COUNT = 86;
    public static readonly LEAST = 87;
    public static readonly GREATEST = 88;
    public static readonly IN = 89;
    public static readonly AND = 90;
    public static readonly OR = 91;
    public static readonly NOT = 92;
    public static readonly COMPLEMENT = 93;
    public static readonly UNION = 94;
    public static readonly INTERSECTION = 95;
    public static readonly DIFFERENCE = 96;
    public static readonly INDEX = 97;
    public static readonly TIME_UNIT = 98;
    public static readonly DAYS = 99;
    public static readonly WEEKS = 100;
    public static readonly MONTHS = 101;
    public static readonly YEARS = 102;
    public static readonly MINIMUM_BETWEEN = 103;
    public static readonly MAXIMUM_BETWEEN = 104;
    public static readonly TOTAL_BETWEEN = 105;
    public static readonly FIXED_WINDOW = 106;
    public static readonly ROLLING_WINDOW = 107;
    public static readonly PERIOD = 108;
    public static readonly WS = 109;
    public static readonly CARE_SITE = 110;
    public static readonly CONDITION_OCCURRENCE = 111;
    public static readonly DRUG_EXPOSURE = 112;
    public static readonly MEASUREMENT = 113;
    public static readonly OBSERVATION = 114;
    public static readonly PERSON = 115;
    public static readonly PROCEDURE_OCCURRENCE = 116;
    public static readonly PROVIDER = 117;
    public static readonly VISIT_OCCURRENCE = 118;
    public static readonly QUALIFIED_CARE_SITE = 119;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 120;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 121;
    public static readonly QUALIFIED_MEASUREMENT = 122;
    public static readonly QUALIFIED_OBSERVATION = 123;
    public static readonly QUALIFIED_PERSON = 124;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 125;
    public static readonly QUALIFIED_PROVIDER = 126;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 127;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 128;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 129;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 130;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 131;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 132;
    public static readonly SUBJECT_VARIABLE_PERSON = 133;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 134;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 135;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 136;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 137;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 138;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 139;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 140;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 141;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 142;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 143;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 144;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 145;
    public static readonly PERSON_INT_ATTRIBUTE = 146;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 147;
    public static readonly QUANTITY = 148;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 149;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 150;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 151;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 152;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 153;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 154;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 155;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 156;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 157;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 158;
    public static readonly COMMON_STRING_ATTRIBUTE = 159;
    public static readonly GENDER_SOURCE_VALUE = 160;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 161;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 162;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 163;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 164;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 165;
    public static readonly PERSON_STRING_ATTRIBUTE = 166;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 167;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 168;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 169;
    public static readonly RULE_simple_event = 0;
    public static readonly RULE_condition_occurrence_event = 1;
    public static readonly RULE_drug_exposure_event = 2;
    public static readonly RULE_measurement_event = 3;
    public static readonly RULE_observation_event = 4;
    public static readonly RULE_procedure_occurrence_event = 5;
    public static readonly RULE_visit_occurrence_event = 6;
    public static readonly RULE_condition_occurrence_event_definition = 7;
    public static readonly RULE_drug_exposure_event_definition = 8;
    public static readonly RULE_measurement_event_definition = 9;
    public static readonly RULE_observation_event_definition = 10;
    public static readonly RULE_procedure_occurrence_event_definition = 11;
    public static readonly RULE_visit_occurrence_event_definition = 12;
    public static readonly RULE_condition_occurrence_event_criteria = 13;
    public static readonly RULE_condition_occurrence_event_filter = 14;
    public static readonly RULE_condition_occurrence_concept_filters = 15;
    public static readonly RULE_condition_occurrence_concept_group_filter = 16;
    public static readonly RULE_condition_occurrence_concept_filter = 17;
    public static readonly RULE_condition_occurrence_uniqueness_filters = 18;
    public static readonly RULE_condition_occurrence_uniqueness_filter = 19;
    public static readonly RULE_condition_occurrence_related_entity_filters = 20;
    public static readonly RULE_condition_occurrence_related_entity_filter = 21;
    public static readonly RULE_condition_occurrence_sub_filter = 22;
    public static readonly RULE_condition_occurrence_error_sub_filter = 23;
    public static readonly RULE_condition_occurrence_error_filter = 24;
    public static readonly RULE_drug_exposure_event_criteria = 25;
    public static readonly RULE_drug_exposure_event_filter = 26;
    public static readonly RULE_drug_exposure_concept_filters = 27;
    public static readonly RULE_drug_exposure_concept_group_filter = 28;
    public static readonly RULE_drug_exposure_concept_filter = 29;
    public static readonly RULE_drug_exposure_numeric_filters = 30;
    public static readonly RULE_drug_exposure_float_filter = 31;
    public static readonly RULE_drug_exposure_int_filter = 32;
    public static readonly RULE_drug_exposure_uniqueness_filters = 33;
    public static readonly RULE_drug_exposure_uniqueness_filter = 34;
    public static readonly RULE_drug_exposure_related_entity_filters = 35;
    public static readonly RULE_drug_exposure_related_entity_filter = 36;
    public static readonly RULE_drug_exposure_error_filter = 37;
    public static readonly RULE_measurement_event_criteria = 38;
    public static readonly RULE_measurement_event_filter = 39;
    public static readonly RULE_measurement_concept_filters = 40;
    public static readonly RULE_measurement_concept_group_filter = 41;
    public static readonly RULE_measurement_concept_filter = 42;
    public static readonly RULE_measurement_numeric_filters = 43;
    public static readonly RULE_measurement_float_filter = 44;
    public static readonly RULE_measurement_uniqueness_filters = 45;
    public static readonly RULE_measurement_uniqueness_filter = 46;
    public static readonly RULE_measurement_related_entity_filters = 47;
    public static readonly RULE_measurement_related_entity_filter = 48;
    public static readonly RULE_measurement_error_filter = 49;
    public static readonly RULE_observation_event_criteria = 50;
    public static readonly RULE_observation_event_filter = 51;
    public static readonly RULE_observation_concept_filters = 52;
    public static readonly RULE_observation_concept_group_filter = 53;
    public static readonly RULE_observation_concept_filter = 54;
    public static readonly RULE_observation_numeric_filters = 55;
    public static readonly RULE_observation_float_filter = 56;
    public static readonly RULE_observation_uniqueness_filters = 57;
    public static readonly RULE_observation_uniqueness_filter = 58;
    public static readonly RULE_observation_related_entity_filters = 59;
    public static readonly RULE_observation_related_entity_filter = 60;
    public static readonly RULE_observation_error_filter = 61;
    public static readonly RULE_procedure_occurrence_event_criteria = 62;
    public static readonly RULE_procedure_occurrence_event_filter = 63;
    public static readonly RULE_procedure_occurrence_concept_filters = 64;
    public static readonly RULE_procedure_occurrence_concept_group_filter = 65;
    public static readonly RULE_procedure_occurrence_concept_filter = 66;
    public static readonly RULE_procedure_occurrence_numeric_filters = 67;
    public static readonly RULE_procedure_occurrence_int_filter = 68;
    public static readonly RULE_procedure_occurrence_uniqueness_filters = 69;
    public static readonly RULE_procedure_occurrence_uniqueness_filter = 70;
    public static readonly RULE_procedure_occurrence_related_entity_filters = 71;
    public static readonly RULE_procedure_occurrence_related_entity_filter = 72;
    public static readonly RULE_procedure_occurrence_error_filter = 73;
    public static readonly RULE_provider_concept_filters = 74;
    public static readonly RULE_provider_concept_group_filter = 75;
    public static readonly RULE_provider_concept_filter = 76;
    public static readonly RULE_provider_sub_filter = 77;
    public static readonly RULE_provider_error_sub_filter = 78;
    public static readonly RULE_visit_occurrence_event_criteria = 79;
    public static readonly RULE_visit_occurrence_event_filter = 80;
    public static readonly RULE_visit_occurrence_concept_filters = 81;
    public static readonly RULE_visit_occurrence_concept_group_filter = 82;
    public static readonly RULE_visit_occurrence_concept_filter = 83;
    public static readonly RULE_visit_occurrence_uniqueness_filters = 84;
    public static readonly RULE_visit_occurrence_uniqueness_filter = 85;
    public static readonly RULE_visit_occurrence_related_entity_filters = 86;
    public static readonly RULE_visit_occurrence_related_entity_filter = 87;
    public static readonly RULE_visit_occurrence_sub_filter = 88;
    public static readonly RULE_visit_occurrence_error_sub_filter = 89;
    public static readonly RULE_visit_occurrence_error_filter = 90;
    public static readonly RULE_comparison_op = 91;
    public static readonly RULE_simple_uniqueness_filter = 92;
    public static readonly RULE_simple_uniqueness_filter_window = 93;
    public static readonly RULE_fixed_window_uniqueness_filter = 94;
    public static readonly RULE_rolling_window_uniqueness_filter = 95;
    public static readonly RULE_simple_event_float = 96;
    public static readonly RULE_simple_event_int = 97;
    public static readonly RULE_concept_group_selection = 98;

    public static readonly literalNames = [
        null, null, "'CONCEPT_FILTER'", "'CF'", null, "'NUMERIC_FILTER'", 
        "'NF'", null, "'STRING_FILTER'", "'SF'", null, "'UNIQUENESS_FILTER'", 
        "'UF'", null, "'RELATED_ENTITY_FILTER'", "'RF'", null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, "'::'", "'SUBJECTS_VARIABLE'", 
        null, "'QUALIFIED_MERGED_EVENT'", "'QUALIFIED_SEQUENCE_EVENT'", 
        "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", "NUMERIC_FILTER", 
        "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", "STRING_FILTER_ABBR", 
        "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", "RF", "RELATED_ENTITY_FILTER", 
        "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", 
        "QUALIFIED_DRUG_EXPOSURE_ALIAS", "QUALIFIED_MEASUREMENT_ALIAS", 
        "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", 
        "QUALIFIED_PROVIDER_ALIAS", "QUALIFIED_VISIT_OCCURRENCE_ALIAS", 
        "QUALIFIED_DERIVED_EVENT_NAME", "SUBJECT_VARIABLE_CARE_SITE_ALIAS", 
        "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", 
        "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", "SUBJECT_VARIABLE_OBSERVATION_ALIAS", 
        "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_PROVIDER_ALIAS", 
        "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", 
        "CONCEPT_GROUP", "CARE_SITE_ALIAS", "CONDITION_OCCURRENCE_ALIAS", 
        "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", "OBSERVATION_ALIAS", 
        "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", "PROVIDER_ALIAS", 
        "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", "SEQUENCE_EVENT_NAME", 
        "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", "NAMESPACE_QUALIFIER", 
        "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", "QUALIFIED_SEQUENCE_EVENT", 
        "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", "SUBJECT_VARIABLE_SEQUENCE_EVENT", 
        "SUBJECT_VARIABLE_INSTANCE_EVENT", "MERGED_EVENT", "SEQUENCE_EVENT", 
        "INSTANCE_EVENT", "DERIVED_EVENT", "LINE_COMMENT", "INT", "M", "D", 
        "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", "SEMICOLON", "COMMA", 
        "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", "CONTAINS", "NEQ", 
        "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", "COUNT", "LEAST", 
        "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", 
        "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", 
        "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", 
        "ROLLING_WINDOW", "PERIOD", "WS", "CARE_SITE", "CONDITION_OCCURRENCE", 
        "DRUG_EXPOSURE", "MEASUREMENT", "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", 
        "PROVIDER", "VISIT_OCCURRENCE", "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", 
        "QUALIFIED_DRUG_EXPOSURE", "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", 
        "QUALIFIED_PERSON", "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", 
        "QUALIFIED_VISIT_OCCURRENCE", "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];
    public static readonly ruleNames = [
        "simple_event", "condition_occurrence_event", "drug_exposure_event", 
        "measurement_event", "observation_event", "procedure_occurrence_event", 
        "visit_occurrence_event", "condition_occurrence_event_definition", 
        "drug_exposure_event_definition", "measurement_event_definition", 
        "observation_event_definition", "procedure_occurrence_event_definition", 
        "visit_occurrence_event_definition", "condition_occurrence_event_criteria", 
        "condition_occurrence_event_filter", "condition_occurrence_concept_filters", 
        "condition_occurrence_concept_group_filter", "condition_occurrence_concept_filter", 
        "condition_occurrence_uniqueness_filters", "condition_occurrence_uniqueness_filter", 
        "condition_occurrence_related_entity_filters", "condition_occurrence_related_entity_filter", 
        "condition_occurrence_sub_filter", "condition_occurrence_error_sub_filter", 
        "condition_occurrence_error_filter", "drug_exposure_event_criteria", 
        "drug_exposure_event_filter", "drug_exposure_concept_filters", "drug_exposure_concept_group_filter", 
        "drug_exposure_concept_filter", "drug_exposure_numeric_filters", 
        "drug_exposure_float_filter", "drug_exposure_int_filter", "drug_exposure_uniqueness_filters", 
        "drug_exposure_uniqueness_filter", "drug_exposure_related_entity_filters", 
        "drug_exposure_related_entity_filter", "drug_exposure_error_filter", 
        "measurement_event_criteria", "measurement_event_filter", "measurement_concept_filters", 
        "measurement_concept_group_filter", "measurement_concept_filter", 
        "measurement_numeric_filters", "measurement_float_filter", "measurement_uniqueness_filters", 
        "measurement_uniqueness_filter", "measurement_related_entity_filters", 
        "measurement_related_entity_filter", "measurement_error_filter", 
        "observation_event_criteria", "observation_event_filter", "observation_concept_filters", 
        "observation_concept_group_filter", "observation_concept_filter", 
        "observation_numeric_filters", "observation_float_filter", "observation_uniqueness_filters", 
        "observation_uniqueness_filter", "observation_related_entity_filters", 
        "observation_related_entity_filter", "observation_error_filter", 
        "procedure_occurrence_event_criteria", "procedure_occurrence_event_filter", 
        "procedure_occurrence_concept_filters", "procedure_occurrence_concept_group_filter", 
        "procedure_occurrence_concept_filter", "procedure_occurrence_numeric_filters", 
        "procedure_occurrence_int_filter", "procedure_occurrence_uniqueness_filters", 
        "procedure_occurrence_uniqueness_filter", "procedure_occurrence_related_entity_filters", 
        "procedure_occurrence_related_entity_filter", "procedure_occurrence_error_filter", 
        "provider_concept_filters", "provider_concept_group_filter", "provider_concept_filter", 
        "provider_sub_filter", "provider_error_sub_filter", "visit_occurrence_event_criteria", 
        "visit_occurrence_event_filter", "visit_occurrence_concept_filters", 
        "visit_occurrence_concept_group_filter", "visit_occurrence_concept_filter", 
        "visit_occurrence_uniqueness_filters", "visit_occurrence_uniqueness_filter", 
        "visit_occurrence_related_entity_filters", "visit_occurrence_related_entity_filter", 
        "visit_occurrence_sub_filter", "visit_occurrence_error_sub_filter", 
        "visit_occurrence_error_filter", "comparison_op", "simple_uniqueness_filter", 
        "simple_uniqueness_filter_window", "fixed_window_uniqueness_filter", 
        "rolling_window_uniqueness_filter", "simple_event_float", "simple_event_int", 
        "concept_group_selection",
    ];

    public get grammarFileName(): string { return "SimpleEvents.g4"; }
    public get literalNames(): (string | null)[] { return SimpleEvents.literalNames; }
    public get symbolicNames(): (string | null)[] { return SimpleEvents.symbolicNames; }
    public get ruleNames(): string[] { return SimpleEvents.ruleNames; }
    public get serializedATN(): number[] { return SimpleEvents._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, SimpleEvents._ATN, SimpleEvents.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public simple_event(): Simple_eventContext {
        let localContext = new Simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 0, SimpleEvents.RULE_simple_event);
        try {
            this.state = 204;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 198;
                this.condition_occurrence_event();
                }
                break;
            case SimpleEvents.DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 199;
                this.drug_exposure_event();
                }
                break;
            case SimpleEvents.MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 200;
                this.measurement_event();
                }
                break;
            case SimpleEvents.OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 201;
                this.observation_event();
                }
                break;
            case SimpleEvents.PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 202;
                this.procedure_occurrence_event();
                }
                break;
            case SimpleEvents.VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 203;
                this.visit_occurrence_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext {
        let localContext = new Condition_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 2, SimpleEvents.RULE_condition_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 206;
            localContext._event_name = this.match(SimpleEvents.CONDITION_OCCURRENCE_ALIAS);
            this.state = 207;
            this.match(SimpleEvents.EQ);
            this.state = 208;
            localContext._event_definition = this.condition_occurrence_event_definition();
            this.state = 209;
            this.match(SimpleEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event(): Drug_exposure_eventContext {
        let localContext = new Drug_exposure_eventContext(this.context, this.state);
        this.enterRule(localContext, 4, SimpleEvents.RULE_drug_exposure_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 211;
            localContext._event_name = this.match(SimpleEvents.DRUG_EXPOSURE_ALIAS);
            this.state = 212;
            this.match(SimpleEvents.EQ);
            this.state = 213;
            localContext._event_definition = this.drug_exposure_event_definition();
            this.state = 214;
            this.match(SimpleEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event(): Measurement_eventContext {
        let localContext = new Measurement_eventContext(this.context, this.state);
        this.enterRule(localContext, 6, SimpleEvents.RULE_measurement_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 216;
            localContext._event_name = this.match(SimpleEvents.MEASUREMENT_ALIAS);
            this.state = 217;
            this.match(SimpleEvents.EQ);
            this.state = 218;
            localContext._event_definition = this.measurement_event_definition();
            this.state = 219;
            this.match(SimpleEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event(): Observation_eventContext {
        let localContext = new Observation_eventContext(this.context, this.state);
        this.enterRule(localContext, 8, SimpleEvents.RULE_observation_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 221;
            localContext._event_name = this.match(SimpleEvents.OBSERVATION_ALIAS);
            this.state = 222;
            this.match(SimpleEvents.EQ);
            this.state = 223;
            localContext._event_definition = this.observation_event_definition();
            this.state = 224;
            this.match(SimpleEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext {
        let localContext = new Procedure_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 10, SimpleEvents.RULE_procedure_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 226;
            localContext._event_name = this.match(SimpleEvents.PROCEDURE_OCCURRENCE_ALIAS);
            this.state = 227;
            this.match(SimpleEvents.EQ);
            this.state = 228;
            localContext._event_definition = this.procedure_occurrence_event_definition();
            this.state = 229;
            this.match(SimpleEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext {
        let localContext = new Visit_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 12, SimpleEvents.RULE_visit_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 231;
            localContext._event_name = this.match(SimpleEvents.VISIT_OCCURRENCE_ALIAS);
            this.state = 232;
            this.match(SimpleEvents.EQ);
            this.state = 233;
            localContext._event_definition = this.visit_occurrence_event_definition();
            this.state = 234;
            this.match(SimpleEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        let localContext = new Condition_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 14, SimpleEvents.RULE_condition_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 236;
            localContext._prefix = this.match(SimpleEvents.CONDITION_OCCURRENCE);
            this.state = 237;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 239;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 9218) !== 0)) {
                {
                this.state = 238;
                localContext._criteria = this.condition_occurrence_event_criteria();
                }
            }

            this.state = 241;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        let localContext = new Drug_exposure_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 16, SimpleEvents.RULE_drug_exposure_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 243;
            localContext._prefix = this.match(SimpleEvents.DRUG_EXPOSURE);
            this.state = 244;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 246;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 9234) !== 0)) {
                {
                this.state = 245;
                localContext._criteria = this.drug_exposure_event_criteria();
                }
            }

            this.state = 248;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        let localContext = new Measurement_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 18, SimpleEvents.RULE_measurement_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 250;
            localContext._prefix = this.match(SimpleEvents.MEASUREMENT);
            this.state = 251;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 253;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 9234) !== 0)) {
                {
                this.state = 252;
                localContext._criteria = this.measurement_event_criteria();
                }
            }

            this.state = 255;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        let localContext = new Observation_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 20, SimpleEvents.RULE_observation_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 257;
            localContext._prefix = this.match(SimpleEvents.OBSERVATION);
            this.state = 258;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 260;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 9234) !== 0)) {
                {
                this.state = 259;
                localContext._criteria = this.observation_event_criteria();
                }
            }

            this.state = 262;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        let localContext = new Procedure_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 22, SimpleEvents.RULE_procedure_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 264;
            localContext._prefix = this.match(SimpleEvents.PROCEDURE_OCCURRENCE);
            this.state = 265;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 267;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 9234) !== 0)) {
                {
                this.state = 266;
                localContext._criteria = this.procedure_occurrence_event_criteria();
                }
            }

            this.state = 269;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        let localContext = new Visit_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 24, SimpleEvents.RULE_visit_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 271;
            localContext._prefix = this.match(SimpleEvents.VISIT_OCCURRENCE);
            this.state = 272;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 274;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 9218) !== 0)) {
                {
                this.state = 273;
                localContext._criteria = this.visit_occurrence_event_criteria();
                }
            }

            this.state = 276;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext {
        let localContext = new Condition_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 26, SimpleEvents.RULE_condition_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 278;
            this.condition_occurrence_event_filter();
            this.state = 283;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 71) {
                {
                {
                this.state = 279;
                this.match(SimpleEvents.COMMA);
                this.state = 280;
                this.condition_occurrence_event_filter();
                }
                }
                this.state = 285;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext {
        let localContext = new Condition_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 28, SimpleEvents.RULE_condition_occurrence_event_filter);
        try {
            this.state = 290;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 8, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 286;
                this.condition_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 287;
                this.condition_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 288;
                this.condition_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 289;
                this.condition_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext {
        let localContext = new Condition_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 30, SimpleEvents.RULE_condition_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 292;
            this.match(SimpleEvents.CF);
            this.state = 293;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 296;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 9, this.context) ) {
            case 1:
                {
                this.state = 294;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 295;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            this.state = 298;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext {
        let localContext = new Condition_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 32, SimpleEvents.RULE_condition_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 300;
            this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 301;
            this.match(SimpleEvents.IN);
            this.state = 302;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext {
        let localContext = new Condition_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 34, SimpleEvents.RULE_condition_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 304;
            this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 305;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 72 || _la === 78)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 306;
            this.match(SimpleEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext {
        let localContext = new Condition_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 36, SimpleEvents.RULE_condition_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 308;
            this.match(SimpleEvents.UF);
            this.state = 309;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 310;
            this.condition_occurrence_uniqueness_filter();
            this.state = 311;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        let localContext = new Condition_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 38, SimpleEvents.RULE_condition_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 315;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.MINIMUM_BETWEEN:
                {
                this.state = 313;
                this.simple_uniqueness_filter();
                }
                break;
            case SimpleEvents.FIXED_WINDOW:
            case SimpleEvents.ROLLING_WINDOW:
                {
                this.state = 314;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 317;
            localContext._date_attr = this.match(SimpleEvents.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext {
        let localContext = new Condition_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 40, SimpleEvents.RULE_condition_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 319;
            this.match(SimpleEvents.RF);
            this.state = 320;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 321;
            this.condition_occurrence_related_entity_filter();
            this.state = 322;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        let localContext = new Condition_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 42, SimpleEvents.RULE_condition_occurrence_related_entity_filter);
        try {
            this.state = 326;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 324;
                this.provider_sub_filter();
                }
                break;
            case SimpleEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 325;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext {
        let localContext = new Condition_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 44, SimpleEvents.RULE_condition_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 328;
            this.match(SimpleEvents.CONDITION_OCCURRENCE);
            this.state = 331;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 12, this.context) ) {
            case 1:
                {
                this.state = 329;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 330;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext {
        let localContext = new Condition_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 46, SimpleEvents.RULE_condition_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 343;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 13, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 334;
                this.match(SimpleEvents.CONDITION_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 335;
                this.match(SimpleEvents.CONDITION_OCCURRENCE);
                this.state = 336;
                this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 337;
                this.match(SimpleEvents.CONDITION_OCCURRENCE);
                this.state = 338;
                this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 339;
                this.match(SimpleEvents.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 340;
                this.match(SimpleEvents.CONDITION_OCCURRENCE);
                this.state = 341;
                this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 342;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext {
        let localContext = new Condition_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 48, SimpleEvents.RULE_condition_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 429;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 14, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 345;
                this.match(SimpleEvents.CF);
                this.state = 346;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 347;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 348;
                this.match(SimpleEvents.CF);
                this.state = 349;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 350;
                this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 351;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 352;
                this.match(SimpleEvents.CF);
                this.state = 353;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 354;
                this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 355;
                this.match(SimpleEvents.IN);
                this.state = 356;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 357;
                this.match(SimpleEvents.CF);
                this.state = 358;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 359;
                this.match(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 360;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 361;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 362;
                this.match(SimpleEvents.UF);
                this.state = 363;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 364;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 365;
                this.match(SimpleEvents.UF);
                this.state = 366;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 367;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 368;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 369;
                this.match(SimpleEvents.UF);
                this.state = 370;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 371;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 372;
                this.simple_event_int();
                this.state = 373;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 375;
                this.match(SimpleEvents.UF);
                this.state = 376;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 377;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 378;
                this.simple_event_int();
                this.state = 379;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 380;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 382;
                this.match(SimpleEvents.UF);
                this.state = 383;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 384;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 385;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 386;
                this.match(SimpleEvents.UF);
                this.state = 387;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 388;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 389;
                this.simple_event_int();
                this.state = 390;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 392;
                this.match(SimpleEvents.UF);
                this.state = 393;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 394;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 395;
                this.simple_event_int();
                this.state = 396;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 397;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 399;
                this.match(SimpleEvents.UF);
                this.state = 400;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 401;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 402;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 403;
                this.match(SimpleEvents.UF);
                this.state = 404;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 405;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 406;
                this.simple_event_int();
                this.state = 407;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 409;
                this.match(SimpleEvents.UF);
                this.state = 410;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 411;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 412;
                this.simple_event_int();
                this.state = 413;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 414;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 416;
                this.match(SimpleEvents.RF);
                this.state = 417;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 418;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 419;
                this.match(SimpleEvents.RF);
                this.state = 420;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 421;
                this.provider_error_sub_filter();
                this.state = 422;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 424;
                this.match(SimpleEvents.RF);
                this.state = 425;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 426;
                this.visit_occurrence_error_sub_filter();
                this.state = 427;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext {
        let localContext = new Drug_exposure_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 50, SimpleEvents.RULE_drug_exposure_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 431;
            this.drug_exposure_event_filter();
            this.state = 436;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 71) {
                {
                {
                this.state = 432;
                this.match(SimpleEvents.COMMA);
                this.state = 433;
                this.drug_exposure_event_filter();
                }
                }
                this.state = 438;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext {
        let localContext = new Drug_exposure_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 52, SimpleEvents.RULE_drug_exposure_event_filter);
        try {
            this.state = 444;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 16, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 439;
                this.drug_exposure_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 440;
                this.drug_exposure_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 441;
                this.drug_exposure_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 442;
                this.drug_exposure_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 443;
                this.drug_exposure_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext {
        let localContext = new Drug_exposure_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 54, SimpleEvents.RULE_drug_exposure_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 446;
            this.match(SimpleEvents.CF);
            this.state = 447;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 450;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 17, this.context) ) {
            case 1:
                {
                this.state = 448;
                this.drug_exposure_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 449;
                this.drug_exposure_concept_filter();
                }
                break;
            }
            this.state = 452;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext {
        let localContext = new Drug_exposure_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 56, SimpleEvents.RULE_drug_exposure_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 454;
            this.match(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 455;
            this.match(SimpleEvents.IN);
            this.state = 456;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext {
        let localContext = new Drug_exposure_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 58, SimpleEvents.RULE_drug_exposure_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 458;
            this.match(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 459;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 72 || _la === 78)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 460;
            this.match(SimpleEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext {
        let localContext = new Drug_exposure_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 60, SimpleEvents.RULE_drug_exposure_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 462;
            this.match(SimpleEvents.NF);
            this.state = 463;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 466;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.QUANTITY:
                {
                this.state = 464;
                this.drug_exposure_float_filter();
                }
                break;
            case SimpleEvents.DRUG_EXPOSURE_INT_ATTRIBUTE:
                {
                this.state = 465;
                this.drug_exposure_int_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 468;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext {
        let localContext = new Drug_exposure_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 62, SimpleEvents.RULE_drug_exposure_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 470;
            this.match(SimpleEvents.QUANTITY);
            this.state = 471;
            this.comparison_op();
            this.state = 472;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext {
        let localContext = new Drug_exposure_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 64, SimpleEvents.RULE_drug_exposure_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 474;
            this.match(SimpleEvents.DRUG_EXPOSURE_INT_ATTRIBUTE);
            this.state = 475;
            this.comparison_op();
            this.state = 476;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext {
        let localContext = new Drug_exposure_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 66, SimpleEvents.RULE_drug_exposure_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 478;
            this.match(SimpleEvents.UF);
            this.state = 479;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 480;
            this.drug_exposure_uniqueness_filter();
            this.state = 481;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        let localContext = new Drug_exposure_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 68, SimpleEvents.RULE_drug_exposure_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 485;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.MINIMUM_BETWEEN:
                {
                this.state = 483;
                this.simple_uniqueness_filter();
                }
                break;
            case SimpleEvents.FIXED_WINDOW:
            case SimpleEvents.ROLLING_WINDOW:
                {
                this.state = 484;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 487;
            this.match(SimpleEvents.DRUG_EXPOSURE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext {
        let localContext = new Drug_exposure_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 70, SimpleEvents.RULE_drug_exposure_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 489;
            this.match(SimpleEvents.RF);
            this.state = 490;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 491;
            this.drug_exposure_related_entity_filter();
            this.state = 492;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        let localContext = new Drug_exposure_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 72, SimpleEvents.RULE_drug_exposure_related_entity_filter);
        try {
            this.state = 496;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 494;
                this.provider_sub_filter();
                }
                break;
            case SimpleEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 495;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext {
        let localContext = new Drug_exposure_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 74, SimpleEvents.RULE_drug_exposure_error_filter);
        let _la: number;
        try {
            this.state = 605;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 21, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 498;
                this.match(SimpleEvents.CF);
                this.state = 499;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 500;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 501;
                this.match(SimpleEvents.CF);
                this.state = 502;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 503;
                this.match(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 504;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 505;
                this.match(SimpleEvents.CF);
                this.state = 506;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 507;
                this.match(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 508;
                this.match(SimpleEvents.IN);
                this.state = 509;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 510;
                this.match(SimpleEvents.CF);
                this.state = 511;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 512;
                this.match(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 513;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 514;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 515;
                this.match(SimpleEvents.NF);
                this.state = 516;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 517;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 518;
                this.match(SimpleEvents.NF);
                this.state = 519;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 520;
                this.match(SimpleEvents.QUANTITY);
                this.state = 521;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 522;
                this.match(SimpleEvents.NF);
                this.state = 523;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 524;
                this.match(SimpleEvents.QUANTITY);
                this.state = 525;
                this.comparison_op();
                this.state = 526;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 528;
                this.match(SimpleEvents.NF);
                this.state = 529;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 530;
                this.match(SimpleEvents.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 531;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 532;
                this.match(SimpleEvents.NF);
                this.state = 533;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 534;
                this.match(SimpleEvents.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 535;
                this.comparison_op();
                this.state = 536;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 538;
                this.match(SimpleEvents.UF);
                this.state = 539;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 540;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 541;
                this.match(SimpleEvents.UF);
                this.state = 542;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 543;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 544;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 545;
                this.match(SimpleEvents.UF);
                this.state = 546;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 547;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 548;
                this.simple_event_int();
                this.state = 549;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 551;
                this.match(SimpleEvents.UF);
                this.state = 552;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 553;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 554;
                this.simple_event_int();
                this.state = 555;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 556;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 558;
                this.match(SimpleEvents.UF);
                this.state = 559;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 560;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 561;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 562;
                this.match(SimpleEvents.UF);
                this.state = 563;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 564;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 565;
                this.simple_event_int();
                this.state = 566;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 568;
                this.match(SimpleEvents.UF);
                this.state = 569;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 570;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 571;
                this.simple_event_int();
                this.state = 572;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 573;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 575;
                this.match(SimpleEvents.UF);
                this.state = 576;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 577;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 578;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 579;
                this.match(SimpleEvents.UF);
                this.state = 580;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 581;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 582;
                this.simple_event_int();
                this.state = 583;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 585;
                this.match(SimpleEvents.UF);
                this.state = 586;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 587;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 588;
                this.simple_event_int();
                this.state = 589;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 590;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 592;
                this.match(SimpleEvents.RF);
                this.state = 593;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 594;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 595;
                this.match(SimpleEvents.RF);
                this.state = 596;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 597;
                this.provider_error_sub_filter();
                this.state = 598;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 600;
                this.match(SimpleEvents.RF);
                this.state = 601;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 602;
                this.visit_occurrence_error_sub_filter();
                this.state = 603;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext {
        let localContext = new Measurement_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 76, SimpleEvents.RULE_measurement_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 607;
            this.measurement_event_filter();
            this.state = 612;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 71) {
                {
                {
                this.state = 608;
                this.match(SimpleEvents.COMMA);
                this.state = 609;
                this.measurement_event_filter();
                }
                }
                this.state = 614;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_filter(): Measurement_event_filterContext {
        let localContext = new Measurement_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 78, SimpleEvents.RULE_measurement_event_filter);
        try {
            this.state = 620;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 23, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 615;
                this.measurement_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 616;
                this.measurement_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 617;
                this.measurement_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 618;
                this.measurement_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 619;
                this.measurement_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext {
        let localContext = new Measurement_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 80, SimpleEvents.RULE_measurement_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 622;
            this.match(SimpleEvents.CF);
            this.state = 623;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 626;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 24, this.context) ) {
            case 1:
                {
                this.state = 624;
                this.measurement_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 625;
                this.measurement_concept_filter();
                }
                break;
            }
            this.state = 628;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext {
        let localContext = new Measurement_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 82, SimpleEvents.RULE_measurement_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 630;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 151 || _la === 157)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 631;
            this.match(SimpleEvents.IN);
            this.state = 632;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filter(): Measurement_concept_filterContext {
        let localContext = new Measurement_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 84, SimpleEvents.RULE_measurement_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 634;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 151 || _la === 157)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 635;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 72 || _la === 78)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 636;
            this.match(SimpleEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext {
        let localContext = new Measurement_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 86, SimpleEvents.RULE_measurement_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 638;
            this.match(SimpleEvents.NF);
            this.state = 639;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 640;
            this.measurement_float_filter();
            this.state = 641;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        let localContext = new Measurement_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 88, SimpleEvents.RULE_measurement_float_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 643;
            _la = this.tokenStream.LA(1);
            if(!(_la === 145 || _la === 147)) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 644;
            this.comparison_op();
            this.state = 645;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext {
        let localContext = new Measurement_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 90, SimpleEvents.RULE_measurement_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 647;
            this.match(SimpleEvents.UF);
            this.state = 648;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 649;
            this.measurement_uniqueness_filter();
            this.state = 650;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        let localContext = new Measurement_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 92, SimpleEvents.RULE_measurement_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 654;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.MINIMUM_BETWEEN:
                {
                this.state = 652;
                this.simple_uniqueness_filter();
                }
                break;
            case SimpleEvents.FIXED_WINDOW:
            case SimpleEvents.ROLLING_WINDOW:
                {
                this.state = 653;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 656;
            this.match(SimpleEvents.MEASUREMENT_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext {
        let localContext = new Measurement_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 94, SimpleEvents.RULE_measurement_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 658;
            this.match(SimpleEvents.RF);
            this.state = 659;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 660;
            this.measurement_related_entity_filter();
            this.state = 661;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        let localContext = new Measurement_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 96, SimpleEvents.RULE_measurement_related_entity_filter);
        try {
            this.state = 665;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 663;
                this.provider_sub_filter();
                }
                break;
            case SimpleEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 664;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_error_filter(): Measurement_error_filterContext {
        let localContext = new Measurement_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 98, SimpleEvents.RULE_measurement_error_filter);
        let _la: number;
        try {
            this.state = 778;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 27, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 667;
                this.match(SimpleEvents.CF);
                this.state = 668;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 669;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 670;
                this.match(SimpleEvents.CF);
                this.state = 671;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 672;
                this.match(SimpleEvents.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 673;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 674;
                this.match(SimpleEvents.CF);
                this.state = 675;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 676;
                this.match(SimpleEvents.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 677;
                this.match(SimpleEvents.IN);
                this.state = 678;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 679;
                this.match(SimpleEvents.CF);
                this.state = 680;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 681;
                this.match(SimpleEvents.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 682;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 683;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 684;
                this.match(SimpleEvents.CF);
                this.state = 685;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 686;
                this.match(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 687;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 688;
                this.match(SimpleEvents.CF);
                this.state = 689;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 690;
                this.match(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 691;
                this.match(SimpleEvents.IN);
                this.state = 692;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 693;
                this.match(SimpleEvents.CF);
                this.state = 694;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 695;
                this.match(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 696;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 697;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 698;
                this.match(SimpleEvents.NF);
                this.state = 699;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 700;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 701;
                this.match(SimpleEvents.NF);
                this.state = 702;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 703;
                _la = this.tokenStream.LA(1);
                if(!(_la === 145 || _la === 147)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 704;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 705;
                this.match(SimpleEvents.NF);
                this.state = 706;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 707;
                _la = this.tokenStream.LA(1);
                if(!(_la === 145 || _la === 147)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 708;
                this.comparison_op();
                this.state = 709;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 711;
                this.match(SimpleEvents.UF);
                this.state = 712;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 713;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 714;
                this.match(SimpleEvents.UF);
                this.state = 715;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 716;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 717;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 718;
                this.match(SimpleEvents.UF);
                this.state = 719;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 720;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 721;
                this.simple_event_int();
                this.state = 722;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 724;
                this.match(SimpleEvents.UF);
                this.state = 725;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 726;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 727;
                this.simple_event_int();
                this.state = 728;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 729;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 731;
                this.match(SimpleEvents.UF);
                this.state = 732;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 733;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 734;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 735;
                this.match(SimpleEvents.UF);
                this.state = 736;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 737;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 738;
                this.simple_event_int();
                this.state = 739;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 741;
                this.match(SimpleEvents.UF);
                this.state = 742;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 743;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 744;
                this.simple_event_int();
                this.state = 745;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 746;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 748;
                this.match(SimpleEvents.UF);
                this.state = 749;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 750;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 751;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 752;
                this.match(SimpleEvents.UF);
                this.state = 753;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 754;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 755;
                this.simple_event_int();
                this.state = 756;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 758;
                this.match(SimpleEvents.UF);
                this.state = 759;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 760;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 761;
                this.simple_event_int();
                this.state = 762;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 763;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 765;
                this.match(SimpleEvents.RF);
                this.state = 766;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 767;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 768;
                this.match(SimpleEvents.RF);
                this.state = 769;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 770;
                this.provider_error_sub_filter();
                this.state = 771;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 773;
                this.match(SimpleEvents.RF);
                this.state = 774;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 775;
                this.visit_occurrence_error_sub_filter();
                this.state = 776;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_criteria(): Observation_event_criteriaContext {
        let localContext = new Observation_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 100, SimpleEvents.RULE_observation_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 780;
            this.observation_event_filter();
            this.state = 785;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 71) {
                {
                {
                this.state = 781;
                this.match(SimpleEvents.COMMA);
                this.state = 782;
                this.observation_event_filter();
                }
                }
                this.state = 787;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_filter(): Observation_event_filterContext {
        let localContext = new Observation_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 102, SimpleEvents.RULE_observation_event_filter);
        try {
            this.state = 793;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 29, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 788;
                this.observation_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 789;
                this.observation_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 790;
                this.observation_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 791;
                this.observation_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 792;
                this.observation_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filters(): Observation_concept_filtersContext {
        let localContext = new Observation_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 104, SimpleEvents.RULE_observation_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 795;
            this.match(SimpleEvents.CF);
            this.state = 796;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 799;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 30, this.context) ) {
            case 1:
                {
                this.state = 797;
                this.observation_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 798;
                this.observation_concept_filter();
                }
                break;
            }
            this.state = 801;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext {
        let localContext = new Observation_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 106, SimpleEvents.RULE_observation_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 803;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 152 || _la === 157)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 804;
            this.match(SimpleEvents.IN);
            this.state = 805;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filter(): Observation_concept_filterContext {
        let localContext = new Observation_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 108, SimpleEvents.RULE_observation_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 807;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 152 || _la === 157)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 808;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 72 || _la === 78)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 809;
            this.match(SimpleEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext {
        let localContext = new Observation_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 110, SimpleEvents.RULE_observation_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 811;
            this.match(SimpleEvents.NF);
            this.state = 812;
            this.match(SimpleEvents.OPEN_PAREN);
            {
            this.state = 813;
            this.observation_float_filter();
            }
            this.state = 814;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_float_filter(): Observation_float_filterContext {
        let localContext = new Observation_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 112, SimpleEvents.RULE_observation_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 816;
            this.match(SimpleEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
            this.state = 817;
            this.comparison_op();
            this.state = 818;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext {
        let localContext = new Observation_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 114, SimpleEvents.RULE_observation_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 820;
            this.match(SimpleEvents.UF);
            this.state = 821;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 822;
            this.observation_uniqueness_filter();
            this.state = 823;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        let localContext = new Observation_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 116, SimpleEvents.RULE_observation_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 827;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.MINIMUM_BETWEEN:
                {
                this.state = 825;
                this.simple_uniqueness_filter();
                }
                break;
            case SimpleEvents.FIXED_WINDOW:
            case SimpleEvents.ROLLING_WINDOW:
                {
                this.state = 826;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 829;
            this.match(SimpleEvents.OBSERVATION_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext {
        let localContext = new Observation_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 118, SimpleEvents.RULE_observation_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 831;
            this.match(SimpleEvents.RF);
            this.state = 832;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 833;
            this.observation_related_entity_filter();
            this.state = 834;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        let localContext = new Observation_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 120, SimpleEvents.RULE_observation_related_entity_filter);
        try {
            this.state = 838;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 836;
                this.provider_sub_filter();
                }
                break;
            case SimpleEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 837;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_error_filter(): Observation_error_filterContext {
        let localContext = new Observation_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 122, SimpleEvents.RULE_observation_error_filter);
        let _la: number;
        try {
            this.state = 951;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 33, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 840;
                this.match(SimpleEvents.CF);
                this.state = 841;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 842;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 843;
                this.match(SimpleEvents.CF);
                this.state = 844;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 845;
                this.match(SimpleEvents.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 846;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 847;
                this.match(SimpleEvents.CF);
                this.state = 848;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 849;
                this.match(SimpleEvents.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 850;
                this.match(SimpleEvents.IN);
                this.state = 851;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 852;
                this.match(SimpleEvents.CF);
                this.state = 853;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 854;
                this.match(SimpleEvents.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 855;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 856;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 857;
                this.match(SimpleEvents.CF);
                this.state = 858;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 859;
                this.match(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 860;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 861;
                this.match(SimpleEvents.CF);
                this.state = 862;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 863;
                this.match(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 864;
                this.match(SimpleEvents.IN);
                this.state = 865;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 866;
                this.match(SimpleEvents.CF);
                this.state = 867;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 868;
                this.match(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 869;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 870;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 871;
                this.match(SimpleEvents.NF);
                this.state = 872;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 873;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 874;
                this.match(SimpleEvents.NF);
                this.state = 875;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 876;
                this.match(SimpleEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 877;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 878;
                this.match(SimpleEvents.NF);
                this.state = 879;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 880;
                this.match(SimpleEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 881;
                this.comparison_op();
                this.state = 882;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 884;
                this.match(SimpleEvents.UF);
                this.state = 885;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 886;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 887;
                this.match(SimpleEvents.UF);
                this.state = 888;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 889;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 890;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 891;
                this.match(SimpleEvents.UF);
                this.state = 892;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 893;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 894;
                this.simple_event_int();
                this.state = 895;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 897;
                this.match(SimpleEvents.UF);
                this.state = 898;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 899;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 900;
                this.simple_event_int();
                this.state = 901;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 902;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 904;
                this.match(SimpleEvents.UF);
                this.state = 905;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 906;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 907;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 908;
                this.match(SimpleEvents.UF);
                this.state = 909;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 910;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 911;
                this.simple_event_int();
                this.state = 912;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 914;
                this.match(SimpleEvents.UF);
                this.state = 915;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 916;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 917;
                this.simple_event_int();
                this.state = 918;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 919;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 921;
                this.match(SimpleEvents.UF);
                this.state = 922;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 923;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 924;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 925;
                this.match(SimpleEvents.UF);
                this.state = 926;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 927;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 928;
                this.simple_event_int();
                this.state = 929;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 931;
                this.match(SimpleEvents.UF);
                this.state = 932;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 933;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 934;
                this.simple_event_int();
                this.state = 935;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 936;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 938;
                this.match(SimpleEvents.RF);
                this.state = 939;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 940;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 941;
                this.match(SimpleEvents.RF);
                this.state = 942;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 943;
                this.provider_error_sub_filter();
                this.state = 944;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 946;
                this.match(SimpleEvents.RF);
                this.state = 947;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 948;
                this.visit_occurrence_error_sub_filter();
                this.state = 949;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext {
        let localContext = new Procedure_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 124, SimpleEvents.RULE_procedure_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 953;
            this.procedure_occurrence_event_filter();
            this.state = 958;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 71) {
                {
                {
                this.state = 954;
                this.match(SimpleEvents.COMMA);
                this.state = 955;
                this.procedure_occurrence_event_filter();
                }
                }
                this.state = 960;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext {
        let localContext = new Procedure_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 126, SimpleEvents.RULE_procedure_occurrence_event_filter);
        try {
            this.state = 966;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 35, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 961;
                this.procedure_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 962;
                this.procedure_occurrence_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 963;
                this.procedure_occurrence_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 964;
                this.procedure_occurrence_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 965;
                this.procedure_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext {
        let localContext = new Procedure_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 128, SimpleEvents.RULE_procedure_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 968;
            this.match(SimpleEvents.CF);
            this.state = 969;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 972;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 36, this.context) ) {
            case 1:
                {
                this.state = 970;
                this.procedure_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 971;
                this.procedure_occurrence_concept_filter();
                }
                break;
            }
            this.state = 974;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext {
        let localContext = new Procedure_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 130, SimpleEvents.RULE_procedure_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 976;
            this.match(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 977;
            this.match(SimpleEvents.IN);
            this.state = 978;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext {
        let localContext = new Procedure_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 132, SimpleEvents.RULE_procedure_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 980;
            this.match(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 981;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 72 || _la === 78)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 982;
            this.match(SimpleEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext {
        let localContext = new Procedure_occurrence_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 134, SimpleEvents.RULE_procedure_occurrence_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 984;
            this.match(SimpleEvents.NF);
            this.state = 985;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 986;
            this.procedure_occurrence_int_filter();
            this.state = 987;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        let localContext = new Procedure_occurrence_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 136, SimpleEvents.RULE_procedure_occurrence_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 989;
            this.match(SimpleEvents.QUANTITY);
            this.state = 990;
            this.comparison_op();
            this.state = 991;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext {
        let localContext = new Procedure_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 138, SimpleEvents.RULE_procedure_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 993;
            this.match(SimpleEvents.UF);
            this.state = 994;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 995;
            this.procedure_occurrence_uniqueness_filter();
            this.state = 996;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        let localContext = new Procedure_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 140, SimpleEvents.RULE_procedure_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1000;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.MINIMUM_BETWEEN:
                {
                this.state = 998;
                this.simple_uniqueness_filter();
                }
                break;
            case SimpleEvents.FIXED_WINDOW:
            case SimpleEvents.ROLLING_WINDOW:
                {
                this.state = 999;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1002;
            this.match(SimpleEvents.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext {
        let localContext = new Procedure_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 142, SimpleEvents.RULE_procedure_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1004;
            this.match(SimpleEvents.RF);
            this.state = 1005;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 1006;
            this.procedure_occurrence_related_entity_filter();
            this.state = 1007;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        let localContext = new Procedure_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 144, SimpleEvents.RULE_procedure_occurrence_related_entity_filter);
        try {
            this.state = 1011;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1009;
                this.provider_sub_filter();
                }
                break;
            case SimpleEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1010;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext {
        let localContext = new Procedure_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 146, SimpleEvents.RULE_procedure_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1110;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 39, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1013;
                this.match(SimpleEvents.CF);
                this.state = 1014;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1015;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1016;
                this.match(SimpleEvents.CF);
                this.state = 1017;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1018;
                this.match(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1019;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1020;
                this.match(SimpleEvents.CF);
                this.state = 1021;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1022;
                this.match(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1023;
                this.match(SimpleEvents.IN);
                this.state = 1024;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1025;
                this.match(SimpleEvents.CF);
                this.state = 1026;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1027;
                this.match(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1028;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1029;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1030;
                this.match(SimpleEvents.NF);
                this.state = 1031;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1032;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1033;
                this.match(SimpleEvents.NF);
                this.state = 1034;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1035;
                this.match(SimpleEvents.QUANTITY);
                this.state = 1036;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1037;
                this.match(SimpleEvents.NF);
                this.state = 1038;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1039;
                this.match(SimpleEvents.QUANTITY);
                this.state = 1040;
                this.comparison_op();
                this.state = 1041;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1043;
                this.match(SimpleEvents.UF);
                this.state = 1044;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1045;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1046;
                this.match(SimpleEvents.UF);
                this.state = 1047;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1048;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 1049;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1050;
                this.match(SimpleEvents.UF);
                this.state = 1051;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1052;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 1053;
                this.simple_event_int();
                this.state = 1054;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1056;
                this.match(SimpleEvents.UF);
                this.state = 1057;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1058;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 1059;
                this.simple_event_int();
                this.state = 1060;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 1061;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1063;
                this.match(SimpleEvents.UF);
                this.state = 1064;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1065;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 1066;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1067;
                this.match(SimpleEvents.UF);
                this.state = 1068;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1069;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 1070;
                this.simple_event_int();
                this.state = 1071;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1073;
                this.match(SimpleEvents.UF);
                this.state = 1074;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1075;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 1076;
                this.simple_event_int();
                this.state = 1077;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 1078;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1080;
                this.match(SimpleEvents.UF);
                this.state = 1081;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1082;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 1083;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1084;
                this.match(SimpleEvents.UF);
                this.state = 1085;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1086;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 1087;
                this.simple_event_int();
                this.state = 1088;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1090;
                this.match(SimpleEvents.UF);
                this.state = 1091;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1092;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 1093;
                this.simple_event_int();
                this.state = 1094;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 1095;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1097;
                this.match(SimpleEvents.RF);
                this.state = 1098;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1099;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1100;
                this.match(SimpleEvents.RF);
                this.state = 1101;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1102;
                this.provider_error_sub_filter();
                this.state = 1103;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1105;
                this.match(SimpleEvents.RF);
                this.state = 1106;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1107;
                this.visit_occurrence_error_sub_filter();
                this.state = 1108;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filters(): Provider_concept_filtersContext {
        let localContext = new Provider_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 148, SimpleEvents.RULE_provider_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1112;
            this.match(SimpleEvents.CF);
            this.state = 1113;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 1116;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 40, this.context) ) {
            case 1:
                {
                this.state = 1114;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1115;
                this.provider_concept_filter();
                }
                break;
            }
            this.state = 1118;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext {
        let localContext = new Provider_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 150, SimpleEvents.RULE_provider_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1120;
            this.match(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1121;
            this.match(SimpleEvents.IN);
            this.state = 1122;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filter(): Provider_concept_filterContext {
        let localContext = new Provider_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 152, SimpleEvents.RULE_provider_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1124;
            this.match(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1125;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 72 || _la === 78)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1126;
            this.match(SimpleEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_sub_filter(): Provider_sub_filterContext {
        let localContext = new Provider_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 154, SimpleEvents.RULE_provider_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1128;
            this.match(SimpleEvents.PROVIDER);
            this.state = 1131;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 41, this.context) ) {
            case 1:
                {
                this.state = 1129;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1130;
                this.provider_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext {
        let localContext = new Provider_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 156, SimpleEvents.RULE_provider_error_sub_filter);
        let _la: number;
        try {
            this.state = 1143;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 42, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1134;
                this.match(SimpleEvents.PROVIDER);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1135;
                this.match(SimpleEvents.PROVIDER);
                this.state = 1136;
                this.match(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1137;
                this.match(SimpleEvents.PROVIDER);
                this.state = 1138;
                this.match(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1139;
                this.match(SimpleEvents.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1140;
                this.match(SimpleEvents.PROVIDER);
                this.state = 1141;
                this.match(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1142;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext {
        let localContext = new Visit_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 158, SimpleEvents.RULE_visit_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1145;
            this.visit_occurrence_event_filter();
            this.state = 1150;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 71) {
                {
                {
                this.state = 1146;
                this.match(SimpleEvents.COMMA);
                this.state = 1147;
                this.visit_occurrence_event_filter();
                }
                }
                this.state = 1152;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext {
        let localContext = new Visit_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 160, SimpleEvents.RULE_visit_occurrence_event_filter);
        try {
            this.state = 1157;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 44, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1153;
                this.visit_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1154;
                this.visit_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1155;
                this.visit_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1156;
                this.visit_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext {
        let localContext = new Visit_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 162, SimpleEvents.RULE_visit_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1159;
            this.match(SimpleEvents.CF);
            this.state = 1160;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 1163;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 45, this.context) ) {
            case 1:
                {
                this.state = 1161;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1162;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1165;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext {
        let localContext = new Visit_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 164, SimpleEvents.RULE_visit_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1167;
            this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1168;
            this.match(SimpleEvents.IN);
            this.state = 1169;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext {
        let localContext = new Visit_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 166, SimpleEvents.RULE_visit_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1171;
            this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1172;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 72 || _la === 78)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1173;
            this.match(SimpleEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext {
        let localContext = new Visit_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 168, SimpleEvents.RULE_visit_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1175;
            this.match(SimpleEvents.UF);
            this.state = 1176;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 1177;
            this.visit_occurrence_uniqueness_filter();
            this.state = 1178;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        let localContext = new Visit_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 170, SimpleEvents.RULE_visit_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1182;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.MINIMUM_BETWEEN:
                {
                this.state = 1180;
                this.simple_uniqueness_filter();
                }
                break;
            case SimpleEvents.FIXED_WINDOW:
            case SimpleEvents.ROLLING_WINDOW:
                {
                this.state = 1181;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1184;
            this.match(SimpleEvents.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext {
        let localContext = new Visit_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 172, SimpleEvents.RULE_visit_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1186;
            this.match(SimpleEvents.RF);
            this.state = 1187;
            this.match(SimpleEvents.OPEN_PAREN);
            this.state = 1188;
            this.visit_occurrence_related_entity_filter();
            this.state = 1189;
            this.match(SimpleEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        let localContext = new Visit_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 174, SimpleEvents.RULE_visit_occurrence_related_entity_filter);
        try {
            this.state = 1193;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1191;
                this.provider_sub_filter();
                }
                break;
            case SimpleEvents.CONDITION_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1192;
                this.condition_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext {
        let localContext = new Visit_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 176, SimpleEvents.RULE_visit_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1195;
            this.match(SimpleEvents.VISIT_OCCURRENCE);
            this.state = 1198;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 48, this.context) ) {
            case 1:
                {
                this.state = 1196;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1197;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext {
        let localContext = new Visit_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 178, SimpleEvents.RULE_visit_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1210;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 49, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1201;
                this.match(SimpleEvents.VISIT_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1202;
                this.match(SimpleEvents.VISIT_OCCURRENCE);
                this.state = 1203;
                this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1204;
                this.match(SimpleEvents.VISIT_OCCURRENCE);
                this.state = 1205;
                this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1206;
                this.match(SimpleEvents.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1207;
                this.match(SimpleEvents.VISIT_OCCURRENCE);
                this.state = 1208;
                this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1209;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext {
        let localContext = new Visit_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 180, SimpleEvents.RULE_visit_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1296;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 50, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1212;
                this.match(SimpleEvents.CF);
                this.state = 1213;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1214;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1215;
                this.match(SimpleEvents.CF);
                this.state = 1216;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1217;
                this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1218;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1219;
                this.match(SimpleEvents.CF);
                this.state = 1220;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1221;
                this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1222;
                this.match(SimpleEvents.IN);
                this.state = 1223;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1224;
                this.match(SimpleEvents.CF);
                this.state = 1225;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1226;
                this.match(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1227;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 72 || _la === 78)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1228;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1229;
                this.match(SimpleEvents.UF);
                this.state = 1230;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1231;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1232;
                this.match(SimpleEvents.UF);
                this.state = 1233;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1234;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 1235;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1236;
                this.match(SimpleEvents.UF);
                this.state = 1237;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1238;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 1239;
                this.simple_event_int();
                this.state = 1240;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1242;
                this.match(SimpleEvents.UF);
                this.state = 1243;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1244;
                this.match(SimpleEvents.MINIMUM_BETWEEN);
                this.state = 1245;
                this.simple_event_int();
                this.state = 1246;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 1247;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1249;
                this.match(SimpleEvents.UF);
                this.state = 1250;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1251;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 1252;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1253;
                this.match(SimpleEvents.UF);
                this.state = 1254;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1255;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 1256;
                this.simple_event_int();
                this.state = 1257;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1259;
                this.match(SimpleEvents.UF);
                this.state = 1260;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1261;
                this.match(SimpleEvents.FIXED_WINDOW);
                this.state = 1262;
                this.simple_event_int();
                this.state = 1263;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 1264;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1266;
                this.match(SimpleEvents.UF);
                this.state = 1267;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1268;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 1269;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1270;
                this.match(SimpleEvents.UF);
                this.state = 1271;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1272;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 1273;
                this.simple_event_int();
                this.state = 1274;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1276;
                this.match(SimpleEvents.UF);
                this.state = 1277;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1278;
                this.match(SimpleEvents.ROLLING_WINDOW);
                this.state = 1279;
                this.simple_event_int();
                this.state = 1280;
                this.match(SimpleEvents.TIME_UNIT);
                this.state = 1281;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1283;
                this.match(SimpleEvents.RF);
                this.state = 1284;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1285;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1286;
                this.match(SimpleEvents.RF);
                this.state = 1287;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1288;
                this.provider_error_sub_filter();
                this.state = 1289;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1291;
                this.match(SimpleEvents.RF);
                this.state = 1292;
                this.match(SimpleEvents.OPEN_PAREN);
                this.state = 1293;
                this.condition_occurrence_error_sub_filter();
                this.state = 1294;
                this.match(SimpleEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public comparison_op(): Comparison_opContext {
        let localContext = new Comparison_opContext(this.context, this.state);
        this.enterRule(localContext, 182, SimpleEvents.RULE_comparison_op);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1298;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 72)) & ~0x1F) === 0 && ((1 << (_la - 72)) & 1985) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext {
        let localContext = new Simple_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 184, SimpleEvents.RULE_simple_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1300;
            this.match(SimpleEvents.MINIMUM_BETWEEN);
            this.state = 1301;
            this.simple_event_int();
            this.state = 1302;
            this.match(SimpleEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext {
        let localContext = new Simple_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 186, SimpleEvents.RULE_simple_uniqueness_filter_window);
        try {
            this.state = 1306;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SimpleEvents.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1304;
                this.fixed_window_uniqueness_filter();
                }
                break;
            case SimpleEvents.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1305;
                this.rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext {
        let localContext = new Fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 188, SimpleEvents.RULE_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1308;
            this.match(SimpleEvents.FIXED_WINDOW);
            this.state = 1309;
            this.simple_event_int();
            this.state = 1310;
            this.match(SimpleEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext {
        let localContext = new Rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 190, SimpleEvents.RULE_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1312;
            this.match(SimpleEvents.ROLLING_WINDOW);
            this.state = 1313;
            this.simple_event_int();
            this.state = 1314;
            this.match(SimpleEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_float(): Simple_event_floatContext {
        let localContext = new Simple_event_floatContext(this.context, this.state);
        this.enterRule(localContext, 192, SimpleEvents.RULE_simple_event_float);
        let _la: number;
        try {
            this.state = 1324;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 54, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1316;
                this.simple_event_int();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1318;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 63) {
                    {
                    this.state = 1317;
                    this.match(SimpleEvents.INT);
                    }
                }

                this.state = 1320;
                this.match(SimpleEvents.PERIOD);
                this.state = 1322;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 63) {
                    {
                    this.state = 1321;
                    this.match(SimpleEvents.INT);
                    }
                }

                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_int(): Simple_event_intContext {
        let localContext = new Simple_event_intContext(this.context, this.state);
        this.enterRule(localContext, 194, SimpleEvents.RULE_simple_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1326;
            this.match(SimpleEvents.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        let localContext = new Concept_group_selectionContext(this.context, this.state);
        this.enterRule(localContext, 196, SimpleEvents.RULE_concept_group_selection);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1328;
            this.match(SimpleEvents.CONCEPT_GROUP);
            this.state = 1333;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 71) {
                {
                {
                this.state = 1329;
                this.match(SimpleEvents.COMMA);
                this.state = 1330;
                this.match(SimpleEvents.CONCEPT_GROUP);
                }
                }
                this.state = 1335;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,169,1337,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,
        7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,
        13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
        20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,
        26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,
        33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,
        39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,
        46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,
        52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,7,58,2,
        59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,2,65,7,
        65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,7,71,2,
        72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,78,7,
        78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,2,
        85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,
        91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,97,2,
        98,7,98,1,0,1,0,1,0,1,0,1,0,1,0,3,0,205,8,0,1,1,1,1,1,1,1,1,1,1,
        1,2,1,2,1,2,1,2,1,2,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,4,1,4,1,4,1,5,
        1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,1,7,1,7,1,7,3,7,240,8,7,1,7,
        1,7,1,8,1,8,1,8,3,8,247,8,8,1,8,1,8,1,9,1,9,1,9,3,9,254,8,9,1,9,
        1,9,1,10,1,10,1,10,3,10,261,8,10,1,10,1,10,1,11,1,11,1,11,3,11,268,
        8,11,1,11,1,11,1,12,1,12,1,12,3,12,275,8,12,1,12,1,12,1,13,1,13,
        1,13,5,13,282,8,13,10,13,12,13,285,9,13,1,14,1,14,1,14,1,14,3,14,
        291,8,14,1,15,1,15,1,15,1,15,3,15,297,8,15,1,15,1,15,1,16,1,16,1,
        16,1,16,1,17,1,17,1,17,1,17,1,18,1,18,1,18,1,18,1,18,1,19,1,19,3,
        19,316,8,19,1,19,1,19,1,20,1,20,1,20,1,20,1,20,1,21,1,21,3,21,327,
        8,21,1,22,1,22,1,22,3,22,332,8,22,1,23,1,23,1,23,1,23,1,23,1,23,
        1,23,1,23,1,23,1,23,3,23,344,8,23,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        3,24,430,8,24,1,25,1,25,1,25,5,25,435,8,25,10,25,12,25,438,9,25,
        1,26,1,26,1,26,1,26,1,26,3,26,445,8,26,1,27,1,27,1,27,1,27,3,27,
        451,8,27,1,27,1,27,1,28,1,28,1,28,1,28,1,29,1,29,1,29,1,29,1,30,
        1,30,1,30,1,30,3,30,467,8,30,1,30,1,30,1,31,1,31,1,31,1,31,1,32,
        1,32,1,32,1,32,1,33,1,33,1,33,1,33,1,33,1,34,1,34,3,34,486,8,34,
        1,34,1,34,1,35,1,35,1,35,1,35,1,35,1,36,1,36,3,36,497,8,36,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,1,37,3,37,606,8,37,1,38,1,38,1,38,5,38,611,8,38,10,38,12,38,
        614,9,38,1,39,1,39,1,39,1,39,1,39,3,39,621,8,39,1,40,1,40,1,40,1,
        40,3,40,627,8,40,1,40,1,40,1,41,1,41,1,41,1,41,1,42,1,42,1,42,1,
        42,1,43,1,43,1,43,1,43,1,43,1,44,1,44,1,44,1,44,1,45,1,45,1,45,1,
        45,1,45,1,46,1,46,3,46,655,8,46,1,46,1,46,1,47,1,47,1,47,1,47,1,
        47,1,48,1,48,3,48,666,8,48,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,
        49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,3,
        49,779,8,49,1,50,1,50,1,50,5,50,784,8,50,10,50,12,50,787,9,50,1,
        51,1,51,1,51,1,51,1,51,3,51,794,8,51,1,52,1,52,1,52,1,52,3,52,800,
        8,52,1,52,1,52,1,53,1,53,1,53,1,53,1,54,1,54,1,54,1,54,1,55,1,55,
        1,55,1,55,1,55,1,56,1,56,1,56,1,56,1,57,1,57,1,57,1,57,1,57,1,58,
        1,58,3,58,828,8,58,1,58,1,58,1,59,1,59,1,59,1,59,1,59,1,60,1,60,
        3,60,839,8,60,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,
        1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,1,61,3,61,952,8,61,
        1,62,1,62,1,62,5,62,957,8,62,10,62,12,62,960,9,62,1,63,1,63,1,63,
        1,63,1,63,3,63,967,8,63,1,64,1,64,1,64,1,64,3,64,973,8,64,1,64,1,
        64,1,65,1,65,1,65,1,65,1,66,1,66,1,66,1,66,1,67,1,67,1,67,1,67,1,
        67,1,68,1,68,1,68,1,68,1,69,1,69,1,69,1,69,1,69,1,70,1,70,3,70,1001,
        8,70,1,70,1,70,1,71,1,71,1,71,1,71,1,71,1,72,1,72,3,72,1012,8,72,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,3,73,1111,8,73,1,74,1,74,1,74,1,74,
        3,74,1117,8,74,1,74,1,74,1,75,1,75,1,75,1,75,1,76,1,76,1,76,1,76,
        1,77,1,77,1,77,3,77,1132,8,77,1,78,1,78,1,78,1,78,1,78,1,78,1,78,
        1,78,1,78,1,78,3,78,1144,8,78,1,79,1,79,1,79,5,79,1149,8,79,10,79,
        12,79,1152,9,79,1,80,1,80,1,80,1,80,3,80,1158,8,80,1,81,1,81,1,81,
        1,81,3,81,1164,8,81,1,81,1,81,1,82,1,82,1,82,1,82,1,83,1,83,1,83,
        1,83,1,84,1,84,1,84,1,84,1,84,1,85,1,85,3,85,1183,8,85,1,85,1,85,
        1,86,1,86,1,86,1,86,1,86,1,87,1,87,3,87,1194,8,87,1,88,1,88,1,88,
        3,88,1199,8,88,1,89,1,89,1,89,1,89,1,89,1,89,1,89,1,89,1,89,1,89,
        3,89,1211,8,89,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,
        1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,
        1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,
        1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,
        1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,
        1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,
        1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,1,90,3,90,1297,8,90,1,91,
        1,91,1,92,1,92,1,92,1,92,1,93,1,93,3,93,1307,8,93,1,94,1,94,1,94,
        1,94,1,95,1,95,1,95,1,95,1,96,1,96,3,96,1319,8,96,1,96,1,96,3,96,
        1323,8,96,3,96,1325,8,96,1,97,1,97,1,98,1,98,1,98,5,98,1332,8,98,
        10,98,12,98,1335,9,98,1,98,0,0,99,0,2,4,6,8,10,12,14,16,18,20,22,
        24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,
        68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,
        108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,
        140,142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,
        172,174,176,178,180,182,184,186,188,190,192,194,196,0,5,2,0,72,72,
        78,78,2,0,151,151,157,157,2,0,145,145,147,147,2,0,152,152,157,157,
        2,0,72,72,78,82,1432,0,204,1,0,0,0,2,206,1,0,0,0,4,211,1,0,0,0,6,
        216,1,0,0,0,8,221,1,0,0,0,10,226,1,0,0,0,12,231,1,0,0,0,14,236,1,
        0,0,0,16,243,1,0,0,0,18,250,1,0,0,0,20,257,1,0,0,0,22,264,1,0,0,
        0,24,271,1,0,0,0,26,278,1,0,0,0,28,290,1,0,0,0,30,292,1,0,0,0,32,
        300,1,0,0,0,34,304,1,0,0,0,36,308,1,0,0,0,38,315,1,0,0,0,40,319,
        1,0,0,0,42,326,1,0,0,0,44,328,1,0,0,0,46,343,1,0,0,0,48,429,1,0,
        0,0,50,431,1,0,0,0,52,444,1,0,0,0,54,446,1,0,0,0,56,454,1,0,0,0,
        58,458,1,0,0,0,60,462,1,0,0,0,62,470,1,0,0,0,64,474,1,0,0,0,66,478,
        1,0,0,0,68,485,1,0,0,0,70,489,1,0,0,0,72,496,1,0,0,0,74,605,1,0,
        0,0,76,607,1,0,0,0,78,620,1,0,0,0,80,622,1,0,0,0,82,630,1,0,0,0,
        84,634,1,0,0,0,86,638,1,0,0,0,88,643,1,0,0,0,90,647,1,0,0,0,92,654,
        1,0,0,0,94,658,1,0,0,0,96,665,1,0,0,0,98,778,1,0,0,0,100,780,1,0,
        0,0,102,793,1,0,0,0,104,795,1,0,0,0,106,803,1,0,0,0,108,807,1,0,
        0,0,110,811,1,0,0,0,112,816,1,0,0,0,114,820,1,0,0,0,116,827,1,0,
        0,0,118,831,1,0,0,0,120,838,1,0,0,0,122,951,1,0,0,0,124,953,1,0,
        0,0,126,966,1,0,0,0,128,968,1,0,0,0,130,976,1,0,0,0,132,980,1,0,
        0,0,134,984,1,0,0,0,136,989,1,0,0,0,138,993,1,0,0,0,140,1000,1,0,
        0,0,142,1004,1,0,0,0,144,1011,1,0,0,0,146,1110,1,0,0,0,148,1112,
        1,0,0,0,150,1120,1,0,0,0,152,1124,1,0,0,0,154,1128,1,0,0,0,156,1143,
        1,0,0,0,158,1145,1,0,0,0,160,1157,1,0,0,0,162,1159,1,0,0,0,164,1167,
        1,0,0,0,166,1171,1,0,0,0,168,1175,1,0,0,0,170,1182,1,0,0,0,172,1186,
        1,0,0,0,174,1193,1,0,0,0,176,1195,1,0,0,0,178,1210,1,0,0,0,180,1296,
        1,0,0,0,182,1298,1,0,0,0,184,1300,1,0,0,0,186,1306,1,0,0,0,188,1308,
        1,0,0,0,190,1312,1,0,0,0,192,1324,1,0,0,0,194,1326,1,0,0,0,196,1328,
        1,0,0,0,198,205,3,2,1,0,199,205,3,4,2,0,200,205,3,6,3,0,201,205,
        3,8,4,0,202,205,3,10,5,0,203,205,3,12,6,0,204,198,1,0,0,0,204,199,
        1,0,0,0,204,200,1,0,0,0,204,201,1,0,0,0,204,202,1,0,0,0,204,203,
        1,0,0,0,205,1,1,0,0,0,206,207,5,37,0,0,207,208,5,72,0,0,208,209,
        3,14,7,0,209,210,5,70,0,0,210,3,1,0,0,0,211,212,5,38,0,0,212,213,
        5,72,0,0,213,214,3,16,8,0,214,215,5,70,0,0,215,5,1,0,0,0,216,217,
        5,39,0,0,217,218,5,72,0,0,218,219,3,18,9,0,219,220,5,70,0,0,220,
        7,1,0,0,0,221,222,5,40,0,0,222,223,5,72,0,0,223,224,3,20,10,0,224,
        225,5,70,0,0,225,9,1,0,0,0,226,227,5,42,0,0,227,228,5,72,0,0,228,
        229,3,22,11,0,229,230,5,70,0,0,230,11,1,0,0,0,231,232,5,44,0,0,232,
        233,5,72,0,0,233,234,3,24,12,0,234,235,5,70,0,0,235,13,1,0,0,0,236,
        237,5,111,0,0,237,239,5,68,0,0,238,240,3,26,13,0,239,238,1,0,0,0,
        239,240,1,0,0,0,240,241,1,0,0,0,241,242,5,69,0,0,242,15,1,0,0,0,
        243,244,5,112,0,0,244,246,5,68,0,0,245,247,3,50,25,0,246,245,1,0,
        0,0,246,247,1,0,0,0,247,248,1,0,0,0,248,249,5,69,0,0,249,17,1,0,
        0,0,250,251,5,113,0,0,251,253,5,68,0,0,252,254,3,76,38,0,253,252,
        1,0,0,0,253,254,1,0,0,0,254,255,1,0,0,0,255,256,5,69,0,0,256,19,
        1,0,0,0,257,258,5,114,0,0,258,260,5,68,0,0,259,261,3,100,50,0,260,
        259,1,0,0,0,260,261,1,0,0,0,261,262,1,0,0,0,262,263,5,69,0,0,263,
        21,1,0,0,0,264,265,5,116,0,0,265,267,5,68,0,0,266,268,3,124,62,0,
        267,266,1,0,0,0,267,268,1,0,0,0,268,269,1,0,0,0,269,270,5,69,0,0,
        270,23,1,0,0,0,271,272,5,118,0,0,272,274,5,68,0,0,273,275,3,158,
        79,0,274,273,1,0,0,0,274,275,1,0,0,0,275,276,1,0,0,0,276,277,5,69,
        0,0,277,25,1,0,0,0,278,283,3,28,14,0,279,280,5,71,0,0,280,282,3,
        28,14,0,281,279,1,0,0,0,282,285,1,0,0,0,283,281,1,0,0,0,283,284,
        1,0,0,0,284,27,1,0,0,0,285,283,1,0,0,0,286,291,3,30,15,0,287,291,
        3,36,18,0,288,291,3,40,20,0,289,291,3,48,24,0,290,286,1,0,0,0,290,
        287,1,0,0,0,290,288,1,0,0,0,290,289,1,0,0,0,291,29,1,0,0,0,292,293,
        5,1,0,0,293,296,5,68,0,0,294,297,3,32,16,0,295,297,3,34,17,0,296,
        294,1,0,0,0,296,295,1,0,0,0,297,298,1,0,0,0,298,299,5,69,0,0,299,
        31,1,0,0,0,300,301,5,149,0,0,301,302,5,89,0,0,302,303,3,196,98,0,
        303,33,1,0,0,0,304,305,5,149,0,0,305,306,7,0,0,0,306,307,5,51,0,
        0,307,35,1,0,0,0,308,309,5,10,0,0,309,310,5,68,0,0,310,311,3,38,
        19,0,311,312,5,69,0,0,312,37,1,0,0,0,313,316,3,184,92,0,314,316,
        3,186,93,0,315,313,1,0,0,0,315,314,1,0,0,0,316,317,1,0,0,0,317,318,
        5,137,0,0,318,39,1,0,0,0,319,320,5,13,0,0,320,321,5,68,0,0,321,322,
        3,42,21,0,322,323,5,69,0,0,323,41,1,0,0,0,324,327,3,154,77,0,325,
        327,3,176,88,0,326,324,1,0,0,0,326,325,1,0,0,0,327,43,1,0,0,0,328,
        331,5,111,0,0,329,332,3,32,16,0,330,332,3,34,17,0,331,329,1,0,0,
        0,331,330,1,0,0,0,332,45,1,0,0,0,333,344,1,0,0,0,334,344,5,111,0,
        0,335,336,5,111,0,0,336,344,5,149,0,0,337,338,5,111,0,0,338,339,
        5,149,0,0,339,344,5,89,0,0,340,341,5,111,0,0,341,342,5,149,0,0,342,
        344,7,0,0,0,343,333,1,0,0,0,343,334,1,0,0,0,343,335,1,0,0,0,343,
        337,1,0,0,0,343,340,1,0,0,0,344,47,1,0,0,0,345,346,5,1,0,0,346,347,
        5,68,0,0,347,430,5,69,0,0,348,349,5,1,0,0,349,350,5,68,0,0,350,351,
        5,149,0,0,351,430,5,69,0,0,352,353,5,1,0,0,353,354,5,68,0,0,354,
        355,5,149,0,0,355,356,5,89,0,0,356,430,5,69,0,0,357,358,5,1,0,0,
        358,359,5,68,0,0,359,360,5,149,0,0,360,361,7,0,0,0,361,430,5,69,
        0,0,362,363,5,10,0,0,363,364,5,68,0,0,364,430,5,69,0,0,365,366,5,
        10,0,0,366,367,5,68,0,0,367,368,5,103,0,0,368,430,5,69,0,0,369,370,
        5,10,0,0,370,371,5,68,0,0,371,372,5,103,0,0,372,373,3,194,97,0,373,
        374,5,69,0,0,374,430,1,0,0,0,375,376,5,10,0,0,376,377,5,68,0,0,377,
        378,5,103,0,0,378,379,3,194,97,0,379,380,5,98,0,0,380,381,5,69,0,
        0,381,430,1,0,0,0,382,383,5,10,0,0,383,384,5,68,0,0,384,385,5,106,
        0,0,385,430,5,69,0,0,386,387,5,10,0,0,387,388,5,68,0,0,388,389,5,
        106,0,0,389,390,3,194,97,0,390,391,5,69,0,0,391,430,1,0,0,0,392,
        393,5,10,0,0,393,394,5,68,0,0,394,395,5,106,0,0,395,396,3,194,97,
        0,396,397,5,98,0,0,397,398,5,69,0,0,398,430,1,0,0,0,399,400,5,10,
        0,0,400,401,5,68,0,0,401,402,5,107,0,0,402,430,5,69,0,0,403,404,
        5,10,0,0,404,405,5,68,0,0,405,406,5,107,0,0,406,407,3,194,97,0,407,
        408,5,69,0,0,408,430,1,0,0,0,409,410,5,10,0,0,410,411,5,68,0,0,411,
        412,5,107,0,0,412,413,3,194,97,0,413,414,5,98,0,0,414,415,5,69,0,
        0,415,430,1,0,0,0,416,417,5,13,0,0,417,418,5,68,0,0,418,430,5,69,
        0,0,419,420,5,13,0,0,420,421,5,68,0,0,421,422,3,156,78,0,422,423,
        5,69,0,0,423,430,1,0,0,0,424,425,5,13,0,0,425,426,5,68,0,0,426,427,
        3,178,89,0,427,428,5,69,0,0,428,430,1,0,0,0,429,345,1,0,0,0,429,
        348,1,0,0,0,429,352,1,0,0,0,429,357,1,0,0,0,429,362,1,0,0,0,429,
        365,1,0,0,0,429,369,1,0,0,0,429,375,1,0,0,0,429,382,1,0,0,0,429,
        386,1,0,0,0,429,392,1,0,0,0,429,399,1,0,0,0,429,403,1,0,0,0,429,
        409,1,0,0,0,429,416,1,0,0,0,429,419,1,0,0,0,429,424,1,0,0,0,430,
        49,1,0,0,0,431,436,3,52,26,0,432,433,5,71,0,0,433,435,3,52,26,0,
        434,432,1,0,0,0,435,438,1,0,0,0,436,434,1,0,0,0,436,437,1,0,0,0,
        437,51,1,0,0,0,438,436,1,0,0,0,439,445,3,54,27,0,440,445,3,60,30,
        0,441,445,3,66,33,0,442,445,3,70,35,0,443,445,3,74,37,0,444,439,
        1,0,0,0,444,440,1,0,0,0,444,441,1,0,0,0,444,442,1,0,0,0,444,443,
        1,0,0,0,445,53,1,0,0,0,446,447,5,1,0,0,447,450,5,68,0,0,448,451,
        3,56,28,0,449,451,3,58,29,0,450,448,1,0,0,0,450,449,1,0,0,0,451,
        452,1,0,0,0,452,453,5,69,0,0,453,55,1,0,0,0,454,455,5,150,0,0,455,
        456,5,89,0,0,456,457,3,196,98,0,457,57,1,0,0,0,458,459,5,150,0,0,
        459,460,7,0,0,0,460,461,5,51,0,0,461,59,1,0,0,0,462,463,5,4,0,0,
        463,466,5,68,0,0,464,467,3,62,31,0,465,467,3,64,32,0,466,464,1,0,
        0,0,466,465,1,0,0,0,467,468,1,0,0,0,468,469,5,69,0,0,469,61,1,0,
        0,0,470,471,5,148,0,0,471,472,3,182,91,0,472,473,3,192,96,0,473,
        63,1,0,0,0,474,475,5,144,0,0,475,476,3,182,91,0,476,477,3,194,97,
        0,477,65,1,0,0,0,478,479,5,10,0,0,479,480,5,68,0,0,480,481,3,68,
        34,0,481,482,5,69,0,0,482,67,1,0,0,0,483,486,3,184,92,0,484,486,
        3,186,93,0,485,483,1,0,0,0,485,484,1,0,0,0,486,487,1,0,0,0,487,488,
        5,138,0,0,488,69,1,0,0,0,489,490,5,13,0,0,490,491,5,68,0,0,491,492,
        3,72,36,0,492,493,5,69,0,0,493,71,1,0,0,0,494,497,3,154,77,0,495,
        497,3,176,88,0,496,494,1,0,0,0,496,495,1,0,0,0,497,73,1,0,0,0,498,
        499,5,1,0,0,499,500,5,68,0,0,500,606,5,69,0,0,501,502,5,1,0,0,502,
        503,5,68,0,0,503,504,5,150,0,0,504,606,5,69,0,0,505,506,5,1,0,0,
        506,507,5,68,0,0,507,508,5,150,0,0,508,509,5,89,0,0,509,606,5,69,
        0,0,510,511,5,1,0,0,511,512,5,68,0,0,512,513,5,150,0,0,513,514,7,
        0,0,0,514,606,5,69,0,0,515,516,5,4,0,0,516,517,5,68,0,0,517,606,
        5,69,0,0,518,519,5,4,0,0,519,520,5,68,0,0,520,521,5,148,0,0,521,
        606,5,69,0,0,522,523,5,4,0,0,523,524,5,68,0,0,524,525,5,148,0,0,
        525,526,3,182,91,0,526,527,5,69,0,0,527,606,1,0,0,0,528,529,5,4,
        0,0,529,530,5,68,0,0,530,531,5,144,0,0,531,606,5,69,0,0,532,533,
        5,4,0,0,533,534,5,68,0,0,534,535,5,144,0,0,535,536,3,182,91,0,536,
        537,5,69,0,0,537,606,1,0,0,0,538,539,5,10,0,0,539,540,5,68,0,0,540,
        606,5,69,0,0,541,542,5,10,0,0,542,543,5,68,0,0,543,544,5,103,0,0,
        544,606,5,69,0,0,545,546,5,10,0,0,546,547,5,68,0,0,547,548,5,103,
        0,0,548,549,3,194,97,0,549,550,5,69,0,0,550,606,1,0,0,0,551,552,
        5,10,0,0,552,553,5,68,0,0,553,554,5,103,0,0,554,555,3,194,97,0,555,
        556,5,98,0,0,556,557,5,69,0,0,557,606,1,0,0,0,558,559,5,10,0,0,559,
        560,5,68,0,0,560,561,5,106,0,0,561,606,5,69,0,0,562,563,5,10,0,0,
        563,564,5,68,0,0,564,565,5,106,0,0,565,566,3,194,97,0,566,567,5,
        69,0,0,567,606,1,0,0,0,568,569,5,10,0,0,569,570,5,68,0,0,570,571,
        5,106,0,0,571,572,3,194,97,0,572,573,5,98,0,0,573,574,5,69,0,0,574,
        606,1,0,0,0,575,576,5,10,0,0,576,577,5,68,0,0,577,578,5,107,0,0,
        578,606,5,69,0,0,579,580,5,10,0,0,580,581,5,68,0,0,581,582,5,107,
        0,0,582,583,3,194,97,0,583,584,5,69,0,0,584,606,1,0,0,0,585,586,
        5,10,0,0,586,587,5,68,0,0,587,588,5,107,0,0,588,589,3,194,97,0,589,
        590,5,98,0,0,590,591,5,69,0,0,591,606,1,0,0,0,592,593,5,13,0,0,593,
        594,5,68,0,0,594,606,5,69,0,0,595,596,5,13,0,0,596,597,5,68,0,0,
        597,598,3,156,78,0,598,599,5,69,0,0,599,606,1,0,0,0,600,601,5,13,
        0,0,601,602,5,68,0,0,602,603,3,178,89,0,603,604,5,69,0,0,604,606,
        1,0,0,0,605,498,1,0,0,0,605,501,1,0,0,0,605,505,1,0,0,0,605,510,
        1,0,0,0,605,515,1,0,0,0,605,518,1,0,0,0,605,522,1,0,0,0,605,528,
        1,0,0,0,605,532,1,0,0,0,605,538,1,0,0,0,605,541,1,0,0,0,605,545,
        1,0,0,0,605,551,1,0,0,0,605,558,1,0,0,0,605,562,1,0,0,0,605,568,
        1,0,0,0,605,575,1,0,0,0,605,579,1,0,0,0,605,585,1,0,0,0,605,592,
        1,0,0,0,605,595,1,0,0,0,605,600,1,0,0,0,606,75,1,0,0,0,607,612,3,
        78,39,0,608,609,5,71,0,0,609,611,3,78,39,0,610,608,1,0,0,0,611,614,
        1,0,0,0,612,610,1,0,0,0,612,613,1,0,0,0,613,77,1,0,0,0,614,612,1,
        0,0,0,615,621,3,80,40,0,616,621,3,86,43,0,617,621,3,90,45,0,618,
        621,3,94,47,0,619,621,3,98,49,0,620,615,1,0,0,0,620,616,1,0,0,0,
        620,617,1,0,0,0,620,618,1,0,0,0,620,619,1,0,0,0,621,79,1,0,0,0,622,
        623,5,1,0,0,623,626,5,68,0,0,624,627,3,82,41,0,625,627,3,84,42,0,
        626,624,1,0,0,0,626,625,1,0,0,0,627,628,1,0,0,0,628,629,5,69,0,0,
        629,81,1,0,0,0,630,631,7,1,0,0,631,632,5,89,0,0,632,633,3,196,98,
        0,633,83,1,0,0,0,634,635,7,1,0,0,635,636,7,0,0,0,636,637,5,51,0,
        0,637,85,1,0,0,0,638,639,5,4,0,0,639,640,5,68,0,0,640,641,3,88,44,
        0,641,642,5,69,0,0,642,87,1,0,0,0,643,644,7,2,0,0,644,645,3,182,
        91,0,645,646,3,192,96,0,646,89,1,0,0,0,647,648,5,10,0,0,648,649,
        5,68,0,0,649,650,3,92,46,0,650,651,5,69,0,0,651,91,1,0,0,0,652,655,
        3,184,92,0,653,655,3,186,93,0,654,652,1,0,0,0,654,653,1,0,0,0,655,
        656,1,0,0,0,656,657,5,139,0,0,657,93,1,0,0,0,658,659,5,13,0,0,659,
        660,5,68,0,0,660,661,3,96,48,0,661,662,5,69,0,0,662,95,1,0,0,0,663,
        666,3,154,77,0,664,666,3,176,88,0,665,663,1,0,0,0,665,664,1,0,0,
        0,666,97,1,0,0,0,667,668,5,1,0,0,668,669,5,68,0,0,669,779,5,69,0,
        0,670,671,5,1,0,0,671,672,5,68,0,0,672,673,5,151,0,0,673,779,5,69,
        0,0,674,675,5,1,0,0,675,676,5,68,0,0,676,677,5,151,0,0,677,678,5,
        89,0,0,678,779,5,69,0,0,679,680,5,1,0,0,680,681,5,68,0,0,681,682,
        5,151,0,0,682,683,7,0,0,0,683,779,5,69,0,0,684,685,5,1,0,0,685,686,
        5,68,0,0,686,687,5,157,0,0,687,779,5,69,0,0,688,689,5,1,0,0,689,
        690,5,68,0,0,690,691,5,157,0,0,691,692,5,89,0,0,692,779,5,69,0,0,
        693,694,5,1,0,0,694,695,5,68,0,0,695,696,5,157,0,0,696,697,7,0,0,
        0,697,779,5,69,0,0,698,699,5,4,0,0,699,700,5,68,0,0,700,779,5,69,
        0,0,701,702,5,4,0,0,702,703,5,68,0,0,703,704,7,2,0,0,704,779,5,69,
        0,0,705,706,5,4,0,0,706,707,5,68,0,0,707,708,7,2,0,0,708,709,3,182,
        91,0,709,710,5,69,0,0,710,779,1,0,0,0,711,712,5,10,0,0,712,713,5,
        68,0,0,713,779,5,69,0,0,714,715,5,10,0,0,715,716,5,68,0,0,716,717,
        5,103,0,0,717,779,5,69,0,0,718,719,5,10,0,0,719,720,5,68,0,0,720,
        721,5,103,0,0,721,722,3,194,97,0,722,723,5,69,0,0,723,779,1,0,0,
        0,724,725,5,10,0,0,725,726,5,68,0,0,726,727,5,103,0,0,727,728,3,
        194,97,0,728,729,5,98,0,0,729,730,5,69,0,0,730,779,1,0,0,0,731,732,
        5,10,0,0,732,733,5,68,0,0,733,734,5,106,0,0,734,779,5,69,0,0,735,
        736,5,10,0,0,736,737,5,68,0,0,737,738,5,106,0,0,738,739,3,194,97,
        0,739,740,5,69,0,0,740,779,1,0,0,0,741,742,5,10,0,0,742,743,5,68,
        0,0,743,744,5,106,0,0,744,745,3,194,97,0,745,746,5,98,0,0,746,747,
        5,69,0,0,747,779,1,0,0,0,748,749,5,10,0,0,749,750,5,68,0,0,750,751,
        5,107,0,0,751,779,5,69,0,0,752,753,5,10,0,0,753,754,5,68,0,0,754,
        755,5,107,0,0,755,756,3,194,97,0,756,757,5,69,0,0,757,779,1,0,0,
        0,758,759,5,10,0,0,759,760,5,68,0,0,760,761,5,107,0,0,761,762,3,
        194,97,0,762,763,5,98,0,0,763,764,5,69,0,0,764,779,1,0,0,0,765,766,
        5,13,0,0,766,767,5,68,0,0,767,779,5,69,0,0,768,769,5,13,0,0,769,
        770,5,68,0,0,770,771,3,156,78,0,771,772,5,69,0,0,772,779,1,0,0,0,
        773,774,5,13,0,0,774,775,5,68,0,0,775,776,3,178,89,0,776,777,5,69,
        0,0,777,779,1,0,0,0,778,667,1,0,0,0,778,670,1,0,0,0,778,674,1,0,
        0,0,778,679,1,0,0,0,778,684,1,0,0,0,778,688,1,0,0,0,778,693,1,0,
        0,0,778,698,1,0,0,0,778,701,1,0,0,0,778,705,1,0,0,0,778,711,1,0,
        0,0,778,714,1,0,0,0,778,718,1,0,0,0,778,724,1,0,0,0,778,731,1,0,
        0,0,778,735,1,0,0,0,778,741,1,0,0,0,778,748,1,0,0,0,778,752,1,0,
        0,0,778,758,1,0,0,0,778,765,1,0,0,0,778,768,1,0,0,0,778,773,1,0,
        0,0,779,99,1,0,0,0,780,785,3,102,51,0,781,782,5,71,0,0,782,784,3,
        102,51,0,783,781,1,0,0,0,784,787,1,0,0,0,785,783,1,0,0,0,785,786,
        1,0,0,0,786,101,1,0,0,0,787,785,1,0,0,0,788,794,3,104,52,0,789,794,
        3,110,55,0,790,794,3,114,57,0,791,794,3,118,59,0,792,794,3,122,61,
        0,793,788,1,0,0,0,793,789,1,0,0,0,793,790,1,0,0,0,793,791,1,0,0,
        0,793,792,1,0,0,0,794,103,1,0,0,0,795,796,5,1,0,0,796,799,5,68,0,
        0,797,800,3,106,53,0,798,800,3,108,54,0,799,797,1,0,0,0,799,798,
        1,0,0,0,800,801,1,0,0,0,801,802,5,69,0,0,802,105,1,0,0,0,803,804,
        7,3,0,0,804,805,5,89,0,0,805,806,3,196,98,0,806,107,1,0,0,0,807,
        808,7,3,0,0,808,809,7,0,0,0,809,810,5,51,0,0,810,109,1,0,0,0,811,
        812,5,4,0,0,812,813,5,68,0,0,813,814,3,112,56,0,814,815,5,69,0,0,
        815,111,1,0,0,0,816,817,5,147,0,0,817,818,3,182,91,0,818,819,3,192,
        96,0,819,113,1,0,0,0,820,821,5,10,0,0,821,822,5,68,0,0,822,823,3,
        116,58,0,823,824,5,69,0,0,824,115,1,0,0,0,825,828,3,184,92,0,826,
        828,3,186,93,0,827,825,1,0,0,0,827,826,1,0,0,0,828,829,1,0,0,0,829,
        830,5,140,0,0,830,117,1,0,0,0,831,832,5,13,0,0,832,833,5,68,0,0,
        833,834,3,120,60,0,834,835,5,69,0,0,835,119,1,0,0,0,836,839,3,154,
        77,0,837,839,3,176,88,0,838,836,1,0,0,0,838,837,1,0,0,0,839,121,
        1,0,0,0,840,841,5,1,0,0,841,842,5,68,0,0,842,952,5,69,0,0,843,844,
        5,1,0,0,844,845,5,68,0,0,845,846,5,152,0,0,846,952,5,69,0,0,847,
        848,5,1,0,0,848,849,5,68,0,0,849,850,5,152,0,0,850,851,5,89,0,0,
        851,952,5,69,0,0,852,853,5,1,0,0,853,854,5,68,0,0,854,855,5,152,
        0,0,855,856,7,0,0,0,856,952,5,69,0,0,857,858,5,1,0,0,858,859,5,68,
        0,0,859,860,5,157,0,0,860,952,5,69,0,0,861,862,5,1,0,0,862,863,5,
        68,0,0,863,864,5,157,0,0,864,865,5,89,0,0,865,952,5,69,0,0,866,867,
        5,1,0,0,867,868,5,68,0,0,868,869,5,157,0,0,869,870,7,0,0,0,870,952,
        5,69,0,0,871,872,5,4,0,0,872,873,5,68,0,0,873,952,5,69,0,0,874,875,
        5,4,0,0,875,876,5,68,0,0,876,877,5,147,0,0,877,952,5,69,0,0,878,
        879,5,4,0,0,879,880,5,68,0,0,880,881,5,147,0,0,881,882,3,182,91,
        0,882,883,5,69,0,0,883,952,1,0,0,0,884,885,5,10,0,0,885,886,5,68,
        0,0,886,952,5,69,0,0,887,888,5,10,0,0,888,889,5,68,0,0,889,890,5,
        103,0,0,890,952,5,69,0,0,891,892,5,10,0,0,892,893,5,68,0,0,893,894,
        5,103,0,0,894,895,3,194,97,0,895,896,5,69,0,0,896,952,1,0,0,0,897,
        898,5,10,0,0,898,899,5,68,0,0,899,900,5,103,0,0,900,901,3,194,97,
        0,901,902,5,98,0,0,902,903,5,69,0,0,903,952,1,0,0,0,904,905,5,10,
        0,0,905,906,5,68,0,0,906,907,5,106,0,0,907,952,5,69,0,0,908,909,
        5,10,0,0,909,910,5,68,0,0,910,911,5,106,0,0,911,912,3,194,97,0,912,
        913,5,69,0,0,913,952,1,0,0,0,914,915,5,10,0,0,915,916,5,68,0,0,916,
        917,5,106,0,0,917,918,3,194,97,0,918,919,5,98,0,0,919,920,5,69,0,
        0,920,952,1,0,0,0,921,922,5,10,0,0,922,923,5,68,0,0,923,924,5,107,
        0,0,924,952,5,69,0,0,925,926,5,10,0,0,926,927,5,68,0,0,927,928,5,
        107,0,0,928,929,3,194,97,0,929,930,5,69,0,0,930,952,1,0,0,0,931,
        932,5,10,0,0,932,933,5,68,0,0,933,934,5,107,0,0,934,935,3,194,97,
        0,935,936,5,98,0,0,936,937,5,69,0,0,937,952,1,0,0,0,938,939,5,13,
        0,0,939,940,5,68,0,0,940,952,5,69,0,0,941,942,5,13,0,0,942,943,5,
        68,0,0,943,944,3,156,78,0,944,945,5,69,0,0,945,952,1,0,0,0,946,947,
        5,13,0,0,947,948,5,68,0,0,948,949,3,178,89,0,949,950,5,69,0,0,950,
        952,1,0,0,0,951,840,1,0,0,0,951,843,1,0,0,0,951,847,1,0,0,0,951,
        852,1,0,0,0,951,857,1,0,0,0,951,861,1,0,0,0,951,866,1,0,0,0,951,
        871,1,0,0,0,951,874,1,0,0,0,951,878,1,0,0,0,951,884,1,0,0,0,951,
        887,1,0,0,0,951,891,1,0,0,0,951,897,1,0,0,0,951,904,1,0,0,0,951,
        908,1,0,0,0,951,914,1,0,0,0,951,921,1,0,0,0,951,925,1,0,0,0,951,
        931,1,0,0,0,951,938,1,0,0,0,951,941,1,0,0,0,951,946,1,0,0,0,952,
        123,1,0,0,0,953,958,3,126,63,0,954,955,5,71,0,0,955,957,3,126,63,
        0,956,954,1,0,0,0,957,960,1,0,0,0,958,956,1,0,0,0,958,959,1,0,0,
        0,959,125,1,0,0,0,960,958,1,0,0,0,961,967,3,128,64,0,962,967,3,134,
        67,0,963,967,3,138,69,0,964,967,3,142,71,0,965,967,3,146,73,0,966,
        961,1,0,0,0,966,962,1,0,0,0,966,963,1,0,0,0,966,964,1,0,0,0,966,
        965,1,0,0,0,967,127,1,0,0,0,968,969,5,1,0,0,969,972,5,68,0,0,970,
        973,3,130,65,0,971,973,3,132,66,0,972,970,1,0,0,0,972,971,1,0,0,
        0,973,974,1,0,0,0,974,975,5,69,0,0,975,129,1,0,0,0,976,977,5,154,
        0,0,977,978,5,89,0,0,978,979,3,196,98,0,979,131,1,0,0,0,980,981,
        5,154,0,0,981,982,7,0,0,0,982,983,5,51,0,0,983,133,1,0,0,0,984,985,
        5,4,0,0,985,986,5,68,0,0,986,987,3,136,68,0,987,988,5,69,0,0,988,
        135,1,0,0,0,989,990,5,148,0,0,990,991,3,182,91,0,991,992,3,194,97,
        0,992,137,1,0,0,0,993,994,5,10,0,0,994,995,5,68,0,0,995,996,3,140,
        70,0,996,997,5,69,0,0,997,139,1,0,0,0,998,1001,3,184,92,0,999,1001,
        3,186,93,0,1000,998,1,0,0,0,1000,999,1,0,0,0,1001,1002,1,0,0,0,1002,
        1003,5,141,0,0,1003,141,1,0,0,0,1004,1005,5,13,0,0,1005,1006,5,68,
        0,0,1006,1007,3,144,72,0,1007,1008,5,69,0,0,1008,143,1,0,0,0,1009,
        1012,3,154,77,0,1010,1012,3,176,88,0,1011,1009,1,0,0,0,1011,1010,
        1,0,0,0,1012,145,1,0,0,0,1013,1014,5,1,0,0,1014,1015,5,68,0,0,1015,
        1111,5,69,0,0,1016,1017,5,1,0,0,1017,1018,5,68,0,0,1018,1019,5,154,
        0,0,1019,1111,5,69,0,0,1020,1021,5,1,0,0,1021,1022,5,68,0,0,1022,
        1023,5,154,0,0,1023,1024,5,89,0,0,1024,1111,5,69,0,0,1025,1026,5,
        1,0,0,1026,1027,5,68,0,0,1027,1028,5,154,0,0,1028,1029,7,0,0,0,1029,
        1111,5,69,0,0,1030,1031,5,4,0,0,1031,1032,5,68,0,0,1032,1111,5,69,
        0,0,1033,1034,5,4,0,0,1034,1035,5,68,0,0,1035,1036,5,148,0,0,1036,
        1111,5,69,0,0,1037,1038,5,4,0,0,1038,1039,5,68,0,0,1039,1040,5,148,
        0,0,1040,1041,3,182,91,0,1041,1042,5,69,0,0,1042,1111,1,0,0,0,1043,
        1044,5,10,0,0,1044,1045,5,68,0,0,1045,1111,5,69,0,0,1046,1047,5,
        10,0,0,1047,1048,5,68,0,0,1048,1049,5,103,0,0,1049,1111,5,69,0,0,
        1050,1051,5,10,0,0,1051,1052,5,68,0,0,1052,1053,5,103,0,0,1053,1054,
        3,194,97,0,1054,1055,5,69,0,0,1055,1111,1,0,0,0,1056,1057,5,10,0,
        0,1057,1058,5,68,0,0,1058,1059,5,103,0,0,1059,1060,3,194,97,0,1060,
        1061,5,98,0,0,1061,1062,5,69,0,0,1062,1111,1,0,0,0,1063,1064,5,10,
        0,0,1064,1065,5,68,0,0,1065,1066,5,106,0,0,1066,1111,5,69,0,0,1067,
        1068,5,10,0,0,1068,1069,5,68,0,0,1069,1070,5,106,0,0,1070,1071,3,
        194,97,0,1071,1072,5,69,0,0,1072,1111,1,0,0,0,1073,1074,5,10,0,0,
        1074,1075,5,68,0,0,1075,1076,5,106,0,0,1076,1077,3,194,97,0,1077,
        1078,5,98,0,0,1078,1079,5,69,0,0,1079,1111,1,0,0,0,1080,1081,5,10,
        0,0,1081,1082,5,68,0,0,1082,1083,5,107,0,0,1083,1111,5,69,0,0,1084,
        1085,5,10,0,0,1085,1086,5,68,0,0,1086,1087,5,107,0,0,1087,1088,3,
        194,97,0,1088,1089,5,69,0,0,1089,1111,1,0,0,0,1090,1091,5,10,0,0,
        1091,1092,5,68,0,0,1092,1093,5,107,0,0,1093,1094,3,194,97,0,1094,
        1095,5,98,0,0,1095,1096,5,69,0,0,1096,1111,1,0,0,0,1097,1098,5,13,
        0,0,1098,1099,5,68,0,0,1099,1111,5,69,0,0,1100,1101,5,13,0,0,1101,
        1102,5,68,0,0,1102,1103,3,156,78,0,1103,1104,5,69,0,0,1104,1111,
        1,0,0,0,1105,1106,5,13,0,0,1106,1107,5,68,0,0,1107,1108,3,178,89,
        0,1108,1109,5,69,0,0,1109,1111,1,0,0,0,1110,1013,1,0,0,0,1110,1016,
        1,0,0,0,1110,1020,1,0,0,0,1110,1025,1,0,0,0,1110,1030,1,0,0,0,1110,
        1033,1,0,0,0,1110,1037,1,0,0,0,1110,1043,1,0,0,0,1110,1046,1,0,0,
        0,1110,1050,1,0,0,0,1110,1056,1,0,0,0,1110,1063,1,0,0,0,1110,1067,
        1,0,0,0,1110,1073,1,0,0,0,1110,1080,1,0,0,0,1110,1084,1,0,0,0,1110,
        1090,1,0,0,0,1110,1097,1,0,0,0,1110,1100,1,0,0,0,1110,1105,1,0,0,
        0,1111,147,1,0,0,0,1112,1113,5,1,0,0,1113,1116,5,68,0,0,1114,1117,
        3,150,75,0,1115,1117,3,152,76,0,1116,1114,1,0,0,0,1116,1115,1,0,
        0,0,1117,1118,1,0,0,0,1118,1119,5,69,0,0,1119,149,1,0,0,0,1120,1121,
        5,155,0,0,1121,1122,5,89,0,0,1122,1123,3,196,98,0,1123,151,1,0,0,
        0,1124,1125,5,155,0,0,1125,1126,7,0,0,0,1126,1127,5,51,0,0,1127,
        153,1,0,0,0,1128,1131,5,117,0,0,1129,1132,3,150,75,0,1130,1132,3,
        152,76,0,1131,1129,1,0,0,0,1131,1130,1,0,0,0,1132,155,1,0,0,0,1133,
        1144,1,0,0,0,1134,1144,5,117,0,0,1135,1136,5,117,0,0,1136,1144,5,
        155,0,0,1137,1138,5,117,0,0,1138,1139,5,155,0,0,1139,1144,5,89,0,
        0,1140,1141,5,117,0,0,1141,1142,5,155,0,0,1142,1144,7,0,0,0,1143,
        1133,1,0,0,0,1143,1134,1,0,0,0,1143,1135,1,0,0,0,1143,1137,1,0,0,
        0,1143,1140,1,0,0,0,1144,157,1,0,0,0,1145,1150,3,160,80,0,1146,1147,
        5,71,0,0,1147,1149,3,160,80,0,1148,1146,1,0,0,0,1149,1152,1,0,0,
        0,1150,1148,1,0,0,0,1150,1151,1,0,0,0,1151,159,1,0,0,0,1152,1150,
        1,0,0,0,1153,1158,3,162,81,0,1154,1158,3,168,84,0,1155,1158,3,172,
        86,0,1156,1158,3,180,90,0,1157,1153,1,0,0,0,1157,1154,1,0,0,0,1157,
        1155,1,0,0,0,1157,1156,1,0,0,0,1158,161,1,0,0,0,1159,1160,5,1,0,
        0,1160,1163,5,68,0,0,1161,1164,3,164,82,0,1162,1164,3,166,83,0,1163,
        1161,1,0,0,0,1163,1162,1,0,0,0,1164,1165,1,0,0,0,1165,1166,5,69,
        0,0,1166,163,1,0,0,0,1167,1168,5,156,0,0,1168,1169,5,89,0,0,1169,
        1170,3,196,98,0,1170,165,1,0,0,0,1171,1172,5,156,0,0,1172,1173,7,
        0,0,0,1173,1174,5,51,0,0,1174,167,1,0,0,0,1175,1176,5,10,0,0,1176,
        1177,5,68,0,0,1177,1178,3,170,85,0,1178,1179,5,69,0,0,1179,169,1,
        0,0,0,1180,1183,3,184,92,0,1181,1183,3,186,93,0,1182,1180,1,0,0,
        0,1182,1181,1,0,0,0,1183,1184,1,0,0,0,1184,1185,5,142,0,0,1185,171,
        1,0,0,0,1186,1187,5,13,0,0,1187,1188,5,68,0,0,1188,1189,3,174,87,
        0,1189,1190,5,69,0,0,1190,173,1,0,0,0,1191,1194,3,154,77,0,1192,
        1194,3,44,22,0,1193,1191,1,0,0,0,1193,1192,1,0,0,0,1194,175,1,0,
        0,0,1195,1198,5,118,0,0,1196,1199,3,164,82,0,1197,1199,3,166,83,
        0,1198,1196,1,0,0,0,1198,1197,1,0,0,0,1199,177,1,0,0,0,1200,1211,
        1,0,0,0,1201,1211,5,118,0,0,1202,1203,5,118,0,0,1203,1211,5,156,
        0,0,1204,1205,5,118,0,0,1205,1206,5,156,0,0,1206,1211,5,89,0,0,1207,
        1208,5,118,0,0,1208,1209,5,156,0,0,1209,1211,7,0,0,0,1210,1200,1,
        0,0,0,1210,1201,1,0,0,0,1210,1202,1,0,0,0,1210,1204,1,0,0,0,1210,
        1207,1,0,0,0,1211,179,1,0,0,0,1212,1213,5,1,0,0,1213,1214,5,68,0,
        0,1214,1297,5,69,0,0,1215,1216,5,1,0,0,1216,1217,5,68,0,0,1217,1218,
        5,156,0,0,1218,1297,5,69,0,0,1219,1220,5,1,0,0,1220,1221,5,68,0,
        0,1221,1222,5,156,0,0,1222,1223,5,89,0,0,1223,1297,5,69,0,0,1224,
        1225,5,1,0,0,1225,1226,5,68,0,0,1226,1227,5,156,0,0,1227,1228,7,
        0,0,0,1228,1297,5,69,0,0,1229,1230,5,10,0,0,1230,1231,5,68,0,0,1231,
        1297,5,69,0,0,1232,1233,5,10,0,0,1233,1234,5,68,0,0,1234,1235,5,
        103,0,0,1235,1297,5,69,0,0,1236,1237,5,10,0,0,1237,1238,5,68,0,0,
        1238,1239,5,103,0,0,1239,1240,3,194,97,0,1240,1241,5,69,0,0,1241,
        1297,1,0,0,0,1242,1243,5,10,0,0,1243,1244,5,68,0,0,1244,1245,5,103,
        0,0,1245,1246,3,194,97,0,1246,1247,5,98,0,0,1247,1248,5,69,0,0,1248,
        1297,1,0,0,0,1249,1250,5,10,0,0,1250,1251,5,68,0,0,1251,1252,5,106,
        0,0,1252,1297,5,69,0,0,1253,1254,5,10,0,0,1254,1255,5,68,0,0,1255,
        1256,5,106,0,0,1256,1257,3,194,97,0,1257,1258,5,69,0,0,1258,1297,
        1,0,0,0,1259,1260,5,10,0,0,1260,1261,5,68,0,0,1261,1262,5,106,0,
        0,1262,1263,3,194,97,0,1263,1264,5,98,0,0,1264,1265,5,69,0,0,1265,
        1297,1,0,0,0,1266,1267,5,10,0,0,1267,1268,5,68,0,0,1268,1269,5,107,
        0,0,1269,1297,5,69,0,0,1270,1271,5,10,0,0,1271,1272,5,68,0,0,1272,
        1273,5,107,0,0,1273,1274,3,194,97,0,1274,1275,5,69,0,0,1275,1297,
        1,0,0,0,1276,1277,5,10,0,0,1277,1278,5,68,0,0,1278,1279,5,107,0,
        0,1279,1280,3,194,97,0,1280,1281,5,98,0,0,1281,1282,5,69,0,0,1282,
        1297,1,0,0,0,1283,1284,5,13,0,0,1284,1285,5,68,0,0,1285,1297,5,69,
        0,0,1286,1287,5,13,0,0,1287,1288,5,68,0,0,1288,1289,3,156,78,0,1289,
        1290,5,69,0,0,1290,1297,1,0,0,0,1291,1292,5,13,0,0,1292,1293,5,68,
        0,0,1293,1294,3,46,23,0,1294,1295,5,69,0,0,1295,1297,1,0,0,0,1296,
        1212,1,0,0,0,1296,1215,1,0,0,0,1296,1219,1,0,0,0,1296,1224,1,0,0,
        0,1296,1229,1,0,0,0,1296,1232,1,0,0,0,1296,1236,1,0,0,0,1296,1242,
        1,0,0,0,1296,1249,1,0,0,0,1296,1253,1,0,0,0,1296,1259,1,0,0,0,1296,
        1266,1,0,0,0,1296,1270,1,0,0,0,1296,1276,1,0,0,0,1296,1283,1,0,0,
        0,1296,1286,1,0,0,0,1296,1291,1,0,0,0,1297,181,1,0,0,0,1298,1299,
        7,4,0,0,1299,183,1,0,0,0,1300,1301,5,103,0,0,1301,1302,3,194,97,
        0,1302,1303,5,98,0,0,1303,185,1,0,0,0,1304,1307,3,188,94,0,1305,
        1307,3,190,95,0,1306,1304,1,0,0,0,1306,1305,1,0,0,0,1307,187,1,0,
        0,0,1308,1309,5,106,0,0,1309,1310,3,194,97,0,1310,1311,5,98,0,0,
        1311,189,1,0,0,0,1312,1313,5,107,0,0,1313,1314,3,194,97,0,1314,1315,
        5,98,0,0,1315,191,1,0,0,0,1316,1325,3,194,97,0,1317,1319,5,63,0,
        0,1318,1317,1,0,0,0,1318,1319,1,0,0,0,1319,1320,1,0,0,0,1320,1322,
        5,108,0,0,1321,1323,5,63,0,0,1322,1321,1,0,0,0,1322,1323,1,0,0,0,
        1323,1325,1,0,0,0,1324,1316,1,0,0,0,1324,1318,1,0,0,0,1325,193,1,
        0,0,0,1326,1327,5,63,0,0,1327,195,1,0,0,0,1328,1333,5,35,0,0,1329,
        1330,5,71,0,0,1330,1332,5,35,0,0,1331,1329,1,0,0,0,1332,1335,1,0,
        0,0,1333,1331,1,0,0,0,1333,1334,1,0,0,0,1334,197,1,0,0,0,1335,1333,
        1,0,0,0,56,204,239,246,253,260,267,274,283,290,296,315,326,331,343,
        429,436,444,450,466,485,496,605,612,620,626,654,665,778,785,793,
        799,827,838,951,958,966,972,1000,1011,1110,1116,1131,1143,1150,1157,
        1163,1182,1193,1198,1210,1296,1306,1318,1322,1324,1333
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!SimpleEvents.__ATN) {
            SimpleEvents.__ATN = new antlr.ATNDeserializer().deserialize(SimpleEvents._serializedATN);
        }

        return SimpleEvents.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(SimpleEvents.literalNames, SimpleEvents.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return SimpleEvents.vocabulary;
    }

    private static readonly decisionsToDFA = SimpleEvents._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class Simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext | null {
        return this.getRuleContext(0, Condition_occurrence_eventContext);
    }
    public drug_exposure_event(): Drug_exposure_eventContext | null {
        return this.getRuleContext(0, Drug_exposure_eventContext);
    }
    public measurement_event(): Measurement_eventContext | null {
        return this.getRuleContext(0, Measurement_eventContext);
    }
    public observation_event(): Observation_eventContext | null {
        return this.getRuleContext(0, Observation_eventContext);
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext | null {
        return this.getRuleContext(0, Procedure_occurrence_eventContext);
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext | null {
        return this.getRuleContext(0, Visit_occurrence_eventContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_simple_event;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterSimple_event) {
             listener.enterSimple_event(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitSimple_event) {
             listener.exitSimple_event(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_event) {
            return visitor.visitSimple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Condition_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.SEMICOLON, 0)!;
    }
    public CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE_ALIAS, 0)!;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        return this.getRuleContext(0, Condition_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_event;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_event) {
             listener.enterCondition_occurrence_event(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_event) {
             listener.exitCondition_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event) {
            return visitor.visitCondition_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Drug_exposure_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.SEMICOLON, 0)!;
    }
    public DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE_ALIAS, 0)!;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        return this.getRuleContext(0, Drug_exposure_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_event;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_event) {
             listener.enterDrug_exposure_event(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_event) {
             listener.exitDrug_exposure_event(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event) {
            return visitor.visitDrug_exposure_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Measurement_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.SEMICOLON, 0)!;
    }
    public MEASUREMENT_ALIAS(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.MEASUREMENT_ALIAS, 0)!;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        return this.getRuleContext(0, Measurement_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_event;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_event) {
             listener.enterMeasurement_event(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_event) {
             listener.exitMeasurement_event(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event) {
            return visitor.visitMeasurement_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Observation_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.SEMICOLON, 0)!;
    }
    public OBSERVATION_ALIAS(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OBSERVATION_ALIAS, 0)!;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        return this.getRuleContext(0, Observation_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_event;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_event) {
             listener.enterObservation_event(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_event) {
             listener.exitObservation_event(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event) {
            return visitor.visitObservation_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Procedure_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.SEMICOLON, 0)!;
    }
    public PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROCEDURE_OCCURRENCE_ALIAS, 0)!;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        return this.getRuleContext(0, Procedure_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_event;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_event) {
             listener.enterProcedure_occurrence_event(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_event) {
             listener.exitProcedure_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event) {
            return visitor.visitProcedure_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Visit_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.SEMICOLON, 0)!;
    }
    public VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE_ALIAS, 0)!;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        return this.getRuleContext(0, Visit_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_event;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_event) {
             listener.enterVisit_occurrence_event(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_event) {
             listener.exitVisit_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event) {
            return visitor.visitVisit_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Condition_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Condition_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_event_definition;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_event_definition) {
             listener.enterCondition_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_event_definition) {
             listener.exitCondition_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_definition) {
            return visitor.visitCondition_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Drug_exposure_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE, 0)!;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext | null {
        return this.getRuleContext(0, Drug_exposure_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_event_definition;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_event_definition) {
             listener.enterDrug_exposure_event_definition(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_event_definition) {
             listener.exitDrug_exposure_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_definition) {
            return visitor.visitDrug_exposure_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Measurement_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.MEASUREMENT, 0)!;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext | null {
        return this.getRuleContext(0, Measurement_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_event_definition;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_event_definition) {
             listener.enterMeasurement_event_definition(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_event_definition) {
             listener.exitMeasurement_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_definition) {
            return visitor.visitMeasurement_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Observation_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OBSERVATION, 0)!;
    }
    public observation_event_criteria(): Observation_event_criteriaContext | null {
        return this.getRuleContext(0, Observation_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_event_definition;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_event_definition) {
             listener.enterObservation_event_definition(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_event_definition) {
             listener.exitObservation_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_definition) {
            return visitor.visitObservation_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Procedure_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROCEDURE_OCCURRENCE, 0)!;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Procedure_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_event_definition;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_event_definition) {
             listener.enterProcedure_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_event_definition) {
             listener.exitProcedure_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_definition) {
            return visitor.visitProcedure_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Visit_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Visit_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_event_definition;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_event_definition) {
             listener.enterVisit_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_event_definition) {
             listener.exitVisit_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_definition) {
            return visitor.visitVisit_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext[];
    public condition_occurrence_event_filter(i: number): Condition_occurrence_event_filterContext | null;
    public condition_occurrence_event_filter(i?: number): Condition_occurrence_event_filterContext[] | Condition_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Condition_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Condition_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.COMMA);
    	} else {
    		return this.getToken(SimpleEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_event_criteria;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_event_criteria) {
             listener.enterCondition_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_event_criteria) {
             listener.exitCondition_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_criteria) {
            return visitor.visitCondition_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filtersContext);
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filtersContext);
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filtersContext);
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_event_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_event_filter) {
             listener.enterCondition_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_event_filter) {
             listener.exitCondition_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_filter) {
            return visitor.visitCondition_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_concept_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_concept_filters) {
             listener.enterCondition_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_concept_filters) {
             listener.exitCondition_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filters) {
            return visitor.visitCondition_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_concept_group_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_concept_group_filter) {
             listener.enterCondition_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_concept_group_filter) {
             listener.exitCondition_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_group_filter) {
            return visitor.visitCondition_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_concept_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_concept_filter) {
             listener.enterCondition_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_concept_filter) {
             listener.exitCondition_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filter) {
            return visitor.visitCondition_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filters) {
             listener.enterCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filters) {
             listener.exitCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filters) {
            return visitor.visitCondition_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filter) {
             listener.enterCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filter) {
             listener.exitCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filter) {
            return visitor.visitCondition_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_related_entity_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_related_entity_filters) {
             listener.enterCondition_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_related_entity_filters) {
             listener.exitCondition_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filters) {
            return visitor.visitCondition_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_related_entity_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_related_entity_filter) {
             listener.enterCondition_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_related_entity_filter) {
             listener.exitCondition_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filter) {
            return visitor.visitCondition_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_sub_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_sub_filter) {
             listener.enterCondition_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_sub_filter) {
             listener.exitCondition_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_sub_filter) {
            return visitor.visitCondition_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE, 0);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_error_sub_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_error_sub_filter) {
             listener.enterCondition_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_error_sub_filter) {
             listener.exitCondition_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_sub_filter) {
            return visitor.visitCondition_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_condition_occurrence_error_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterCondition_occurrence_error_filter) {
             listener.enterCondition_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitCondition_occurrence_error_filter) {
             listener.exitCondition_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_filter) {
            return visitor.visitCondition_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext[];
    public drug_exposure_event_filter(i: number): Drug_exposure_event_filterContext | null;
    public drug_exposure_event_filter(i?: number): Drug_exposure_event_filterContext[] | Drug_exposure_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Drug_exposure_event_filterContext);
        }

        return this.getRuleContext(i, Drug_exposure_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.COMMA);
    	} else {
    		return this.getToken(SimpleEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_event_criteria;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_event_criteria) {
             listener.enterDrug_exposure_event_criteria(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_event_criteria) {
             listener.exitDrug_exposure_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_criteria) {
            return visitor.visitDrug_exposure_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filtersContext);
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_numeric_filtersContext);
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filtersContext);
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_related_entity_filtersContext);
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_event_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_event_filter) {
             listener.enterDrug_exposure_event_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_event_filter) {
             listener.exitDrug_exposure_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_filter) {
            return visitor.visitDrug_exposure_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_group_filterContext);
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_concept_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_concept_filters) {
             listener.enterDrug_exposure_concept_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_concept_filters) {
             listener.exitDrug_exposure_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filters) {
            return visitor.visitDrug_exposure_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_concept_group_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_concept_group_filter) {
             listener.enterDrug_exposure_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_concept_group_filter) {
             listener.exitDrug_exposure_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_group_filter) {
            return visitor.visitDrug_exposure_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_concept_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_concept_filter) {
             listener.enterDrug_exposure_concept_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_concept_filter) {
             listener.exitDrug_exposure_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filter) {
            return visitor.visitDrug_exposure_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_float_filterContext);
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_int_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_numeric_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_numeric_filters) {
             listener.enterDrug_exposure_numeric_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_numeric_filters) {
             listener.exitDrug_exposure_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_numeric_filters) {
            return visitor.visitDrug_exposure_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_float_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_float_filter) {
             listener.enterDrug_exposure_float_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_float_filter) {
             listener.exitDrug_exposure_float_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_float_filter) {
            return visitor.visitDrug_exposure_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_int_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_int_filter) {
             listener.enterDrug_exposure_int_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_int_filter) {
             listener.exitDrug_exposure_int_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_int_filter) {
            return visitor.visitDrug_exposure_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_uniqueness_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_uniqueness_filters) {
             listener.enterDrug_exposure_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_uniqueness_filters) {
             listener.exitDrug_exposure_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filters) {
            return visitor.visitDrug_exposure_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_uniqueness_filter) {
             listener.enterDrug_exposure_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_uniqueness_filter) {
             listener.exitDrug_exposure_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filter) {
            return visitor.visitDrug_exposure_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        return this.getRuleContext(0, Drug_exposure_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_related_entity_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_related_entity_filters) {
             listener.enterDrug_exposure_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_related_entity_filters) {
             listener.exitDrug_exposure_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filters) {
            return visitor.visitDrug_exposure_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_related_entity_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_related_entity_filter) {
             listener.enterDrug_exposure_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_related_entity_filter) {
             listener.exitDrug_exposure_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filter) {
            return visitor.visitDrug_exposure_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.DRUG_EXPOSURE_INT_ATTRIBUTE, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_drug_exposure_error_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterDrug_exposure_error_filter) {
             listener.enterDrug_exposure_error_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitDrug_exposure_error_filter) {
             listener.exitDrug_exposure_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_error_filter) {
            return visitor.visitDrug_exposure_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_event_filter(): Measurement_event_filterContext[];
    public measurement_event_filter(i: number): Measurement_event_filterContext | null;
    public measurement_event_filter(i?: number): Measurement_event_filterContext[] | Measurement_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Measurement_event_filterContext);
        }

        return this.getRuleContext(i, Measurement_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.COMMA);
    	} else {
    		return this.getToken(SimpleEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_event_criteria;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_event_criteria) {
             listener.enterMeasurement_event_criteria(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_event_criteria) {
             listener.exitMeasurement_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_criteria) {
            return visitor.visitMeasurement_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext | null {
        return this.getRuleContext(0, Measurement_concept_filtersContext);
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext | null {
        return this.getRuleContext(0, Measurement_numeric_filtersContext);
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Measurement_uniqueness_filtersContext);
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext | null {
        return this.getRuleContext(0, Measurement_related_entity_filtersContext);
    }
    public measurement_error_filter(): Measurement_error_filterContext | null {
        return this.getRuleContext(0, Measurement_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_event_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_event_filter) {
             listener.enterMeasurement_event_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_event_filter) {
             listener.exitMeasurement_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_filter) {
            return visitor.visitMeasurement_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_group_filterContext);
    }
    public measurement_concept_filter(): Measurement_concept_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_concept_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_concept_filters) {
             listener.enterMeasurement_concept_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_concept_filters) {
             listener.exitMeasurement_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filters) {
            return visitor.visitMeasurement_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_concept_group_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_concept_group_filter) {
             listener.enterMeasurement_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_concept_group_filter) {
             listener.exitMeasurement_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_group_filter) {
            return visitor.visitMeasurement_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONCEPT, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_concept_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_concept_filter) {
             listener.enterMeasurement_concept_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_concept_filter) {
             listener.exitMeasurement_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filter) {
            return visitor.visitMeasurement_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        return this.getRuleContext(0, Measurement_float_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_numeric_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_numeric_filters) {
             listener.enterMeasurement_numeric_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_numeric_filters) {
             listener.exitMeasurement_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_numeric_filters) {
            return visitor.visitMeasurement_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_float_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_float_filter) {
             listener.enterMeasurement_float_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_float_filter) {
             listener.exitMeasurement_float_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_float_filter) {
            return visitor.visitMeasurement_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        return this.getRuleContext(0, Measurement_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_uniqueness_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_uniqueness_filters) {
             listener.enterMeasurement_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_uniqueness_filters) {
             listener.exitMeasurement_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filters) {
            return visitor.visitMeasurement_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.MEASUREMENT_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_uniqueness_filter) {
             listener.enterMeasurement_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_uniqueness_filter) {
             listener.exitMeasurement_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filter) {
            return visitor.visitMeasurement_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        return this.getRuleContext(0, Measurement_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_related_entity_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_related_entity_filters) {
             listener.enterMeasurement_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_related_entity_filters) {
             listener.exitMeasurement_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filters) {
            return visitor.visitMeasurement_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_related_entity_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_related_entity_filter) {
             listener.enterMeasurement_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_related_entity_filter) {
             listener.exitMeasurement_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filter) {
            return visitor.visitMeasurement_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NF, 0);
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_measurement_error_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterMeasurement_error_filter) {
             listener.enterMeasurement_error_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitMeasurement_error_filter) {
             listener.exitMeasurement_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_error_filter) {
            return visitor.visitMeasurement_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_event_filter(): Observation_event_filterContext[];
    public observation_event_filter(i: number): Observation_event_filterContext | null;
    public observation_event_filter(i?: number): Observation_event_filterContext[] | Observation_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Observation_event_filterContext);
        }

        return this.getRuleContext(i, Observation_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.COMMA);
    	} else {
    		return this.getToken(SimpleEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_event_criteria;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_event_criteria) {
             listener.enterObservation_event_criteria(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_event_criteria) {
             listener.exitObservation_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_criteria) {
            return visitor.visitObservation_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_concept_filters(): Observation_concept_filtersContext | null {
        return this.getRuleContext(0, Observation_concept_filtersContext);
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext | null {
        return this.getRuleContext(0, Observation_numeric_filtersContext);
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Observation_uniqueness_filtersContext);
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext | null {
        return this.getRuleContext(0, Observation_related_entity_filtersContext);
    }
    public observation_error_filter(): Observation_error_filterContext | null {
        return this.getRuleContext(0, Observation_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_event_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_event_filter) {
             listener.enterObservation_event_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_event_filter) {
             listener.exitObservation_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_filter) {
            return visitor.visitObservation_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext | null {
        return this.getRuleContext(0, Observation_concept_group_filterContext);
    }
    public observation_concept_filter(): Observation_concept_filterContext | null {
        return this.getRuleContext(0, Observation_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_concept_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_concept_filters) {
             listener.enterObservation_concept_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_concept_filters) {
             listener.exitObservation_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filters) {
            return visitor.visitObservation_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_concept_group_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_concept_group_filter) {
             listener.enterObservation_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_concept_group_filter) {
             listener.exitObservation_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_group_filter) {
            return visitor.visitObservation_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONCEPT, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_concept_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_concept_filter) {
             listener.enterObservation_concept_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_concept_filter) {
             listener.exitObservation_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filter) {
            return visitor.visitObservation_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public observation_float_filter(): Observation_float_filterContext | null {
        return this.getRuleContext(0, Observation_float_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_numeric_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_numeric_filters) {
             listener.enterObservation_numeric_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_numeric_filters) {
             listener.exitObservation_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_numeric_filters) {
            return visitor.visitObservation_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_float_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_float_filter) {
             listener.enterObservation_float_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_float_filter) {
             listener.exitObservation_float_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_float_filter) {
            return visitor.visitObservation_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        return this.getRuleContext(0, Observation_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_uniqueness_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_uniqueness_filters) {
             listener.enterObservation_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_uniqueness_filters) {
             listener.exitObservation_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filters) {
            return visitor.visitObservation_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OBSERVATION_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_uniqueness_filter) {
             listener.enterObservation_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_uniqueness_filter) {
             listener.exitObservation_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filter) {
            return visitor.visitObservation_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        return this.getRuleContext(0, Observation_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_related_entity_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_related_entity_filters) {
             listener.enterObservation_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_related_entity_filters) {
             listener.exitObservation_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filters) {
            return visitor.visitObservation_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_related_entity_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_related_entity_filter) {
             listener.enterObservation_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_related_entity_filter) {
             listener.exitObservation_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filter) {
            return visitor.visitObservation_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NF, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_observation_error_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterObservation_error_filter) {
             listener.enterObservation_error_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitObservation_error_filter) {
             listener.exitObservation_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_error_filter) {
            return visitor.visitObservation_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext[];
    public procedure_occurrence_event_filter(i: number): Procedure_occurrence_event_filterContext | null;
    public procedure_occurrence_event_filter(i?: number): Procedure_occurrence_event_filterContext[] | Procedure_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Procedure_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Procedure_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.COMMA);
    	} else {
    		return this.getToken(SimpleEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_event_criteria;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_event_criteria) {
             listener.enterProcedure_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_event_criteria) {
             listener.exitProcedure_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_criteria) {
            return visitor.visitProcedure_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filtersContext);
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_numeric_filtersContext);
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filtersContext);
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filtersContext);
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_event_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_event_filter) {
             listener.enterProcedure_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_event_filter) {
             listener.exitProcedure_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_filter) {
            return visitor.visitProcedure_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_group_filterContext);
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_concept_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_concept_filters) {
             listener.enterProcedure_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_concept_filters) {
             listener.exitProcedure_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filters) {
            return visitor.visitProcedure_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_concept_group_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_concept_group_filter) {
             listener.enterProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_concept_group_filter) {
             listener.exitProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_group_filter) {
            return visitor.visitProcedure_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_concept_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_concept_filter) {
             listener.enterProcedure_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_concept_filter) {
             listener.exitProcedure_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filter) {
            return visitor.visitProcedure_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_int_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_numeric_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_numeric_filters) {
             listener.enterProcedure_occurrence_numeric_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_numeric_filters) {
             listener.exitProcedure_occurrence_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_numeric_filters) {
            return visitor.visitProcedure_occurrence_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_int_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_int_filter) {
             listener.enterProcedure_occurrence_int_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_int_filter) {
             listener.exitProcedure_occurrence_int_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_int_filter) {
            return visitor.visitProcedure_occurrence_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filters) {
             listener.enterProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filters) {
             listener.exitProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filters) {
            return visitor.visitProcedure_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filter) {
             listener.enterProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filter) {
             listener.exitProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filter) {
            return visitor.visitProcedure_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_related_entity_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filters) {
             listener.enterProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filters) {
             listener.exitProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filters) {
            return visitor.visitProcedure_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_related_entity_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filter) {
             listener.enterProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filter) {
             listener.exitProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filter) {
            return visitor.visitProcedure_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_procedure_occurrence_error_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProcedure_occurrence_error_filter) {
             listener.enterProcedure_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProcedure_occurrence_error_filter) {
             listener.exitProcedure_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_error_filter) {
            return visitor.visitProcedure_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_provider_concept_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProvider_concept_filters) {
             listener.enterProvider_concept_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProvider_concept_filters) {
             listener.exitProvider_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filters) {
            return visitor.visitProvider_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_provider_concept_group_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProvider_concept_group_filter) {
             listener.enterProvider_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProvider_concept_group_filter) {
             listener.exitProvider_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_group_filter) {
            return visitor.visitProvider_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_provider_concept_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProvider_concept_filter) {
             listener.enterProvider_concept_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProvider_concept_filter) {
             listener.exitProvider_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filter) {
            return visitor.visitProvider_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.PROVIDER, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_provider_sub_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProvider_sub_filter) {
             listener.enterProvider_sub_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProvider_sub_filter) {
             listener.exitProvider_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_sub_filter) {
            return visitor.visitProvider_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.PROVIDER, 0);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.PROVIDER_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_provider_error_sub_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterProvider_error_sub_filter) {
             listener.enterProvider_error_sub_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitProvider_error_sub_filter) {
             listener.exitProvider_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_error_sub_filter) {
            return visitor.visitProvider_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext[];
    public visit_occurrence_event_filter(i: number): Visit_occurrence_event_filterContext | null;
    public visit_occurrence_event_filter(i?: number): Visit_occurrence_event_filterContext[] | Visit_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Visit_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Visit_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.COMMA);
    	} else {
    		return this.getToken(SimpleEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_event_criteria;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_event_criteria) {
             listener.enterVisit_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_event_criteria) {
             listener.exitVisit_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_criteria) {
            return visitor.visitVisit_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filtersContext);
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filtersContext);
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filtersContext);
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_event_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_event_filter) {
             listener.enterVisit_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_event_filter) {
             listener.exitVisit_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_filter) {
            return visitor.visitVisit_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_concept_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_concept_filters) {
             listener.enterVisit_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_concept_filters) {
             listener.exitVisit_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filters) {
            return visitor.visitVisit_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_concept_group_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_concept_group_filter) {
             listener.enterVisit_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_concept_group_filter) {
             listener.exitVisit_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_group_filter) {
            return visitor.visitVisit_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_concept_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_concept_filter) {
             listener.enterVisit_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_concept_filter) {
             listener.exitVisit_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filter) {
            return visitor.visitVisit_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filters) {
             listener.enterVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filters) {
             listener.exitVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filters) {
            return visitor.visitVisit_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filter) {
             listener.enterVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filter) {
             listener.exitVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filter) {
            return visitor.visitVisit_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_related_entity_filters;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_related_entity_filters) {
             listener.enterVisit_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_related_entity_filters) {
             listener.exitVisit_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filters) {
            return visitor.visitVisit_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_related_entity_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_related_entity_filter) {
             listener.enterVisit_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_related_entity_filter) {
             listener.exitVisit_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filter) {
            return visitor.visitVisit_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_sub_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_sub_filter) {
             listener.enterVisit_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_sub_filter) {
             listener.exitVisit_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_sub_filter) {
            return visitor.visitVisit_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE, 0);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_error_sub_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_error_sub_filter) {
             listener.enterVisit_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_error_sub_filter) {
             listener.exitVisit_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_sub_filter) {
            return visitor.visitVisit_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_visit_occurrence_error_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterVisit_occurrence_error_filter) {
             listener.enterVisit_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitVisit_occurrence_error_filter) {
             listener.exitVisit_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_filter) {
            return visitor.visitVisit_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Comparison_opContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.EQ, 0);
    }
    public LT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.LT, 0);
    }
    public GT(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.GT, 0);
    }
    public LTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.LTE, 0);
    }
    public GTE(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.GTE, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_comparison_op;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterComparison_op) {
             listener.enterComparison_op(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitComparison_op) {
             listener.exitComparison_op(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitComparison_op) {
            return visitor.visitComparison_op(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.MINIMUM_BETWEEN, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_simple_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterSimple_uniqueness_filter) {
             listener.enterSimple_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitSimple_uniqueness_filter) {
             listener.exitSimple_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter) {
            return visitor.visitSimple_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Fixed_window_uniqueness_filterContext);
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_simple_uniqueness_filter_window;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterSimple_uniqueness_filter_window) {
             listener.enterSimple_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitSimple_uniqueness_filter_window) {
             listener.exitSimple_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter_window) {
            return visitor.visitSimple_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.FIXED_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterFixed_window_uniqueness_filter) {
             listener.enterFixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitFixed_window_uniqueness_filter) {
             listener.exitFixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitFixed_window_uniqueness_filter) {
            return visitor.visitFixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.ROLLING_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterRolling_window_uniqueness_filter) {
             listener.enterRolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitRolling_window_uniqueness_filter) {
             listener.exitRolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitRolling_window_uniqueness_filter) {
            return visitor.visitRolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_floatContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(SimpleEvents.PERIOD, 0);
    }
    public INT(): antlr.TerminalNode[];
    public INT(i: number): antlr.TerminalNode | null;
    public INT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.INT);
    	} else {
    		return this.getToken(SimpleEvents.INT, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_simple_event_float;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterSimple_event_float) {
             listener.enterSimple_event_float(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitSimple_event_float) {
             listener.exitSimple_event_float(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_float) {
            return visitor.visitSimple_event_float(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(SimpleEvents.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_simple_event_int;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterSimple_event_int) {
             listener.enterSimple_event_int(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitSimple_event_int) {
             listener.exitSimple_event_int(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_int) {
            return visitor.visitSimple_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Concept_group_selectionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT_GROUP(): antlr.TerminalNode[];
    public CONCEPT_GROUP(i: number): antlr.TerminalNode | null;
    public CONCEPT_GROUP(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.CONCEPT_GROUP);
    	} else {
    		return this.getToken(SimpleEvents.CONCEPT_GROUP, i);
    	}
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SimpleEvents.COMMA);
    	} else {
    		return this.getToken(SimpleEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SimpleEvents.RULE_concept_group_selection;
    }
    public override enterRule(listener: SimpleEventsListener): void {
        if(listener.enterConcept_group_selection) {
             listener.enterConcept_group_selection(this);
        }
    }
    public override exitRule(listener: SimpleEventsListener): void {
        if(listener.exitConcept_group_selection) {
             listener.exitConcept_group_selection(this);
        }
    }
    public override accept<Result>(visitor: SimpleEventsVisitor<Result>): Result | null {
        if (visitor.visitConcept_group_selection) {
            return visitor.visitConcept_group_selection(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
